import type { TechMeasureRecommendation } from '@/types';

export const allRecommendations: TechMeasureRecommendation[] = [
  {
    index: '01',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: '% BOİ5 azalması, çamur yaşına yakından bağlıdır. Bu nedenle, atık su arıtma tesislerinde BOİ5 kalitesine ulaşmak için doğru çamur yaşının ayarlanması zorunludur.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '02',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: '% bKOİ azaltımı, çamur yaşına yakından bağlıdır. Bu nedenle, atık su arıtma tesislerinde KOİ kalitesine ulaşmak için doğru çamur yaşının ayarlanması zorunludur.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '03',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Filtreleme ortamının biyolojik kontaminasyonu koliformlarda uyumsuzluğa neden olabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Koliform [bakteri/100 ml]']
  },
  {
    index: '04',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Filtreleme ortamının biyolojik kontaminasyonu koliformlarda uyumsuzluğa neden olabilir. Bunu önlemek için düzenli biyosit arıtması gereklidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Koliform [bakteri/100 ml]']
  },
  {
    index: '05',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Koagülantın doğru seçimi ve dozajı esastır (Jar test deneyleri gereklidir)',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Sülfür',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Toplam-N',
      'Yağ ve Gres',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Toplam-P',
      'AKM (Askıda Katı Madde)',
      'BOİ5'
    ]
  },
  {
    index: '06',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi', 'Basınçlı kum filtresi'],
    text: 'Diferansiyel basınç ölçümü filtre kontaminasyonunu gösterir. Filtre kirlendiğinde, temizleme işlemine başlamalısınız.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Bakır',
      'Toplam-N',
      'Fenol',
      'Kadmiyum',
      'Kobalt',
      'AOX',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Gümüş',
      'Toplam-P',
      'Cıva',
      'Toplam Krom',
      'BOİ5',
      'Kurşun',
      'Çinko',
      'Arsenik',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Nikel'
    ]
  },
  {
    index: '07',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Çoğunluğu çözünebilir renk boyaları (yüksek moleküler ağırlık ve düşük polarite, örneğin turuncu sarı boya gibi) ACF\'de tutulması beklenir. İzolektrik nokta pH değeri adsorpsiyonun artırılması için önemlidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '08',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Amonyak azotu uyumsuzluğu yanlış nitrifikasyon nedeniyle olabilir. Aerobik reaktörde nitrifikasyon meydana gelir, yani amonyak azotunun nitrata dönüşmesi. Bu amaçla reaktör, nitrifikasyon yapan bakterilerin varlığı ile adapte edilmeli ve çamur yaşı uygun olmalıdır (15 günden fazla ve sıcaklık değerine göre ayarlanmalıdır).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Ammonium-N']
  },
  {
    index: '09',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Aktif karbon, kontrol edilecek kimyasal parametre türüne göre seçilmelidir. Tane boyutu, gözenek boyutu ve karbon türü filtre üreticisi tavsiyelerine göre seçilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Kobalt',
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'AOX',
      'Nikel',
      'Gümüş',
      'Cıva',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Fenol',
      'Kadmiyum'
    ]
  },
  {
    index: '10',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Aktif karbon, kontrol edilecek kimyasal parametre türüne göre seçilmelidir. Tane boyutu, gözenek boyutu ve karbon türü filtre üreticisi tavsiyelerine göre seçilmelidir. Su bileşiminizin değişip değişmediğini ve karbon türü veya tane boyutunu değiştirmeniz gerekip gerekmediğini kontrol edin. Unutmayın ki polar ve düşük moleküler ağırlıklı maddeler aktif karbon gözeneklerinde zayıf bir şekilde tutulur.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['BOİ5', 'Toplam-P']
  },
  {
    index: '11',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Aktif karbon, kontrol edilecek kimyasal parametre türüne göre seçilmelidir. Tane boyutu, gözenek boyutu ve karbon türü filtre üreticisi tavsiyelerine göre seçilmelidir. Su bileşiminizin değişip değişmediğini ve karbon türü veya tane boyutunu değiştirmeniz gerekip gerekmediğini kontrol edin. Unutmayın ki polar ve düşük moleküler ağırlıklı maddeler aktif karbon gözeneklerinde zayıf bir şekilde tutulur.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '12',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Adsorpsiyon ekzotermik bir süreçtir. Bu nedenle, sıcaklık arttıkça aktif karbonun kapasitesi azalır. Çok yüksek sıcaklıklarda, adsorpsiyon kapasitesinde bir azalma beklenir. Mevcut sıcaklık aralığında (10 ila 30ºC) bir etki beklenmez. Bu nedenle, suyun sıcaklığının doğru olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Kobalt', 'Arsenik', 'Chrom (VI)', 'Kadmiyum']
  },
  {
    index: '13',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Adsorpsiyon ekzotermik bir süreçtir. Bu nedenle, sıcaklık arttıkça aktif karbonun kapasitesi azalır. Çok yüksek sıcaklıklarda, adsorpsiyon kapasitesinde bir azalma beklenir. Mevcut sıcaklık aralığında (10 ila 30ºC) bir etki beklenmez. Bu nedenle, suyun sıcaklığının doğru olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Çinko',
      'Bakır',
      'Antimon',
      'Toplam-N',
      'Toplam Krom',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Nikel',
      'Gümüş',
      'Toplam-P',
      'AKM (Askıda Katı Madde)',
      'Cıva',
      'BOİ5',
      'Kurşun',
      'Fenol'
    ]
  },
  {
    index: '14',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Adsorpsiyon ekzotermik bir süreçtir. Bu nedenle, sıcaklık arttıkça aktif karbonun kapasitesi azalır. Çok yüksek sıcaklıklarda, adsorpsiyon kapasitesinde bir azalma beklenir. Mevcut sıcaklık aralığında (10 ila 30ºC) bir etki beklenmez. Bu nedenle, suyun sıcaklığının doğru olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '15',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Adsorpsiyon ekzotermik bir süreçtir. Bu nedenle, sıcaklık arttıkça aktif karbonun kapasitesi azalır. Çok yüksek sıcaklıklarda, adsorpsiyon kapasitesinde bir azalma beklenir. Mevcut sıcaklık aralığında (10 ila 30ºC) bir etki beklenmez. Bu nedenle, suyun sıcaklığının doğru olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['AOX']
  },
  {
    index: '16',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Krom6+ hidroksitlerini ayırmak için etkili bir flokülasyon gereklidir. Koagülantın doğru seçimi ve dozajı esastır (Jar test deneyleri gereklidir).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Chrom (VI)']
  },
  {
    index: '17',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Sb-Fe3+ agregatlarını ayırmak için etkili bir flokülasyon gereklidir. Koagülantın doğru seçimi ve dozajı esastır (Jar test deneyleri gereklidir).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Antimon']
  },
  {
    index: '18',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Arsenik hidroksitlerini ayırmak için etkili bir flokülasyon gereklidir. Koagülantın doğru seçimi ve dozajı esastır (Jar test deneyleri gereklidir).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Arsenik']
  },
  {
    index: '19',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Kadmiyum hidroksitlerini ayırmak için etkili bir flokülasyon gereklidir. Koagülantın doğru seçimi ve dozajı esastır (Jar test deneyleri gereklidir).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Kadmiyum']
  },
  {
    index: '20',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Krom hidroksitlerini ayırmak için etkili bir flokülasyon gereklidir. Koagülantın doğru seçimi ve dozajı esastır (Jar test deneyleri gereklidir).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam Krom']
  },
  {
    index: '21',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Bakır hidroksitlerini ayırmak için etkili bir flokülasyon gereklidir. Koagülantın doğru seçimi ve dozajı esastır (Jar test deneyleri gereklidir).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Bakır']
  },
  {
    index: '22',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Kurşun hidroksitlerini ayırmak için etkili bir flokülasyon gereklidir. Koagülantın doğru seçimi ve dozajı esastır (Jar test deneyleri gereklidir).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Kurşun']
  },
  {
    index: '23',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Cıva hidroksitlerini ayırmak için etkili bir flokülasyon gereklidir. Koagülantın doğru seçimi ve dozajı esastır (Jar test deneyleri gereklidir).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Cıva']
  },
  {
    index: '24',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Nikel hidroksitlerini ayırmak için etkili bir flokülasyon gereklidir. Koagülantın doğru seçimi ve dozajı esastır (Jar test deneyleri gereklidir).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Nikel']
  },
  {
    index: '25',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Gümüş hidroksitlerini ayırmak için etkili bir flokülasyon gereklidir. Koagülantın doğru seçimi ve dozajı esastır (Jar test deneyleri gereklidir).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Gümüş']
  },
  {
    index: '26',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Çinko hidroksitlerini ayırmak için etkili bir flokülasyon gereklidir. Koagülantın doğru seçimi ve dozajı esastır (Jar test deneyleri gereklidir).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Çinko']
  },
  {
    index: '27',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Antimon Fe3+ üzerinde adsorbe edilebilir. Polimerik ferrik sülfat ve ferrik klorür gibi reaktifler uygundur. 5 ila 6 pH değerleri önerilir. Tahmini adsorpsiyon kapasitesi yaklaşık 350 mg Sb/g Fe3+ \'dir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Antimon']
  },
  {
    index: '28',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Antimon kompleksleşemez. Bu, kompleks oluşturamayacakları anlamına gelir. Metal kompleksi, bir veya daha fazla metal atomunun bir veya daha fazla ligand ile bağlandığı bir bileşiktir. Ligand, bir veya daha fazla atom üzerinden bir metal merkeze bağlanabilen organik bir bileşiktir. Bu nedenle, metalin fizikokimyasal işlemle uzaklaştırılabilmesi için serbest olması gerekir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Antimon']
  },
  {
    index: '29',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Antimon aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikiminden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Antimon']
  },
  {
    index: '30',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Arsenik kompleksleşemez. Bu, kompleks oluşturamayacakları anlamına gelir. Metal kompleksi, bir veya daha fazla metal atomunun bir veya daha fazla ligand ile bağlandığı bir bileşiktir. Ligand, bir veya daha fazla atom üzerinden bir metal merkeze bağlanabilen organik bir bileşiktir. Bu nedenle, metalin fizikokimyasal işlemle uzaklaştırılabilmesi için serbest olması gerekir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Arsenik']
  },
  {
    index: '31',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Arsenik, konsantrasyonları > 0,1 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikiminden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Arsenik']
  },
  {
    index: '32',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Arsenik, fizikokimyasal bir işlemle ayrılabilmesi için oksitlenmiş 5+ (arsenat) durumda olmalıdır. As3+ çıkarılamaz ve mevcut oksidanlar, örneğin sodyum hipoklorit kullanılarak 5+ \'a oksitlenmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Arsenik']
  },
  {
    index: '33',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'As5+, ferrik hidroksit ile birlikte çöktürülerek uzaklaştırılabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Arsenik']
  },
  {
    index: '34',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Kum filtresi çıkışında AKM konsantrasyonlarının 2,5 ppm\'den az olması beklenir (< 5 NTU).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '35',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Biyobozunur KOİ\'nin kg/gün olarak değeri, yiyecekten kütleye F/M (kg bKOİ/gün/kgVSS) tasarım parametresine göre olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '36',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Kadmiyum, pH 6,5\'te demir hidroksit ile birlikte çöktürülebilir veya pH 8,5 - 10\'da organosülfür ve kireç çöktürmesi ile filtrasyonla uzaklaştırılabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Kadmiyum']
  },
  {
    index: '37',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Kadmiyum kompleksleşemez. Bu, kompleks oluşturamayacakları anlamına gelir. Metal kompleksi, bir veya daha fazla metal atomunun bir veya daha fazla ligand ile bağlandığı bir bileşiktir. Ligand, bir veya daha fazla atom üzerinden bir metal merkeze bağlanabilen organik bir bileşiktir. Bu nedenle, metalin fizikokimyasal işlemle uzaklaştırılabilmesi için serbest olması gerekir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Kadmiyum']
  },
  {
    index: '38',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Kadmiyum, konsantrasyonları > 1 ila 10 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikiminden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Kadmiyum']
  },
  {
    index: '39',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Tavsiye edilen Camp sayısı önerilen 20.000-50.000 u\'dur. Not: Camp sayısı (Gt), hız gradyanı (G, s-1) ile hidrolik bekletme süresi (HRT) çarpımından elde edilen üründür. Bu parametre, hızlı karıştırma ve flokülasyon süreçlerinin tasarımında yaygın olarak kullanılır. Kesin Camp sayısı kavanoz testi (jar test) deneyleriyle elde edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Sülfür',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Yağ ve Gres',
      'Nikel',
      'Gümüş',
      'Cıva',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '40',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Tavsiye edilen Camp sayısı önerilen 20.000-50.000 u\'dur. Not: Camp sayısı (Gt), hız gradyanı (G, s-1) ile hidrolik bekletme süresi (HRT) çarpımından elde edilen üründür. Bu parametre, hızlı karıştırma ve flokülasyon süreçlerinin tasarımında yaygın olarak kullanılır. Kesin Camp sayısı kavanoz testi (jar test) deneyleriyle elde edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '41',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'OD seviyelerini kontrol edin. 2 ile 4 ppm arasında olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)', 'BOİ5']
  },
  {
    index: '42',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'OD seviyelerini kontrol edin. 2 ile 4 ppm arasında olmalıdır (nitrification aşamasında).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '43',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'OD seviyelerini kontrol edin. Oksik aşamada 2 ile 4 ppm arasında olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '44',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'pH değerini kontrol edin ve adsorbe edilecek maddelerin asidik/bazik doğasına göre ayarlayın: Asidik adsorbe edilebilir maddeler, asidik pH değerlerinde en iyi şekilde adsorbe edilir. Aksine, bazik adsorbe edilebilir maddeler bazik pH değerlerinde en iyi şekilde adsorbe edilir. pH değeriniz doğru değilse: pH\'ı düşürmeniz gerekiyorsa, bir asidik reaktif ekleyin ve pH\'ı artırmanız gerekiyorsa bir bazik reaktif ekleyin.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'AOX',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Toplam-N',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Toplam-P',
      'BOİ5',
      'Fenol'
    ]
  },
  {
    index: '45',
    typeId: 'atıksu',
    category: ['Koagülasyon', 'Flokülasyon', 'Toplama tankı'],
    text: 'Kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında çalıştırılması önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Çinko', 'Yağ ve Gres', 'Nikel', 'Gümüş', 'Toplam-P', 'AKM (Askıda Katı Madde)', 'Cıva', 'Kurşun']
  },
  {
    index: '46',
    typeId: 'atıksu',
    category: ['Koagülasyon', 'Flokülasyon'],
    text: 'Kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında çalıştırılması önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Sülfür',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Yağ ve Gres',
      'Toplam Krom',
      'Nikel',
      'Gümüş',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'BOİ5',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '47',
    typeId: 'atıksu',
    category: ['Toplama tankı'],
    text: 'Kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında çalıştırılması önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Arsenik']
  },
  {
    index: '48',
    typeId: 'atıksu',
    category: ['Toplama tankı'],
    text: 'Kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında çalıştırılması önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Sülfür',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Gümüş',
      'Cıva',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '49',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Kimyasal koagülasyon, çözünmeyen BOI5 üzerinde AKM ile aynı şekilde çalışır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '50',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Kimyasal koagülasyon, çözünmeyen KOI üzerinde AKM ile aynı şekilde çalışır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '51',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Kimyasal koagülasyon, çözünmeyen Toplam Azot üzerinde AKM ile aynı şekilde çalışır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '52',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Krom 3+ hidroksit minimum çözünürlüğü, reaktif olarak sodyum hidroksit kullanılarak pH 7,5\'te elde edilir. Çökelme pH\'a hassastır çünkü oluşan çökeltinin yeniden çözünürlük oranı pH\'a bağlıdır. Kireç kullanırken, ortak çöktürme pH 8\'de çalışıldığında daha iyi sonuçlar elde edilmesini sağlar ve reaksiyon pH\'tan daha az bağımsız hale gelir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam Krom']
  },
  {
    index: '53',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Krom 6+ konsantrasyonları > 1 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikiminden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Chrom (VI)']
  },
  {
    index: '54',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Krom VI kompleksleşemez. Bu, kompleks oluşturamayacakları anlamına gelir. Metal kompleksi, bir veya daha fazla metal atomunun bir veya daha fazla ligand ile bağlandığı bir bileşiktir. Ligand, bir veya daha fazla atom üzerinden bir metal merkeze bağlanabilen organik bir bileşiktir. Bu nedenle, metalin fizikokimyasal işlemle uzaklaştırılabilmesi için serbest olması gerekir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Chrom (VI)']
  },
  {
    index: '55',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Kromun fizikokimyasal bir işlemle ayrılabilmesi için indirgenmiş 3+ durumda olması gerekir. Cr6+ çıkarılamaz ve sodyum metabisülfit, sodyum tiyosülfit, demir sülfat gibi mevcut indirgeme maddeleri kullanılarak 3+\'a indirgenmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Chrom (VI)']
  },
  {
    index: '56',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Koagülasyon pH\'ya karşı çok hassastır. Alüminyum 6,5 ile 7,5 pH aralığı gerektirir. Demir ise 7 ile 8 pH aralığında etkilidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)', 'BOİ5', 'Toplam-N', 'AKM (Askıda Katı Madde)']
  },
  {
    index: '57',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Koagülasyon pH\'ya karşı çok hassastır. Demir 7 ile 8 pH değerleri gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Sülfür']
  },
  {
    index: '58',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: 'Önce kaba, ardından ince ekranlar önerilir; filtrasyon boyutu <1-3 mm olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Bakır',
      'Toplam-N',
      'Kadmiyum',
      'Kobalt',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Gümüş',
      'Toplam-P',
      'Cıva',
      'Toplam Krom',
      'BOİ5',
      'Kurşun',
      'Çinko',
      'Arsenik',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Sülfür',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Nikel'
    ]
  },
  {
    index: '59',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Kobalt, aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Kobalt']
  },
  {
    index: '60',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Temas süresi yeterli olmalıdır (HRT) > 10 dakika',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Sülfür',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Toplam-N',
      'pH',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Yağ ve Gres',
      'AKM (Askıda Katı Madde)',
      'BOİ5'
    ]
  },
  {
    index: '61',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Temas süresi yeterli olmalıdır (HRT) > 15 dakika',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Sülfür',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Yağ ve Gres',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Toplam Krom',
      'Nikel',
      'Gümüş',
      'Toplam-P',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Cıva',
      'BOİ5',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '62',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Yoğun karıştırmadan sonra temas süresi yeterli olmalıdır (HRT) > 10 dakika.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Nikel',
      'Gümüş',
      'Toplam-P',
      'Chrom (VI)',
      'Cıva',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '63',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Bakır, sodyum hidroksit kullanılarak pH 8\'de veya kireç kullanılarak pH 8-9\'da hidroksit şeklinde çöktürülebilir. Kireç kullanıldığında daha iyi sonuçlar beklenir. Daha düşük konsantrasyonlu atıksu değerleri için, pH 8,5\'te organosülfürlerle çöktürme önerilmektedir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Bakır']
  },
  {
    index: '64',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Bakır kompleksleşemez. Bu, kompleks oluşturamayacakları anlamına gelir. Metal kompleksi, bir veya daha fazla metal atomunun bir veya daha fazla ligand ile bağlandığı bir bileşiktir. Ligand, bir veya daha fazla atom üzerinden bir metal merkeze bağlanabilen organik bir bileşiktir. Bu nedenle, metalin fizikokimyasal işlemle uzaklaştırılabilmesi için serbest olması gerekir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Bakır']
  },
  {
    index: '65',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Bakır, konsantrasyonları  > 1,0 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Bakır']
  },
  {
    index: '66',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Koçöktürme ve adsorpsiyon, klarifikatörün tabanından reaksiyon tankına yapılan kısmi bir geri dönüşüm ile artırılabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Nikel',
      'Gümüş',
      'Cıva',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '67',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Mevcut işlem sıcaklığı biyolojik reaktörde 16 ila 22ºC arasında değişmektedir; 18-20ºC aralığı tavsiye edilen aralıktır. 16ºC\'nin altındaki düşük sıcaklıklar biyolojik süreci önemli ölçüde yavaşlatacaktır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)', 'BOİ5', 'Toplam-N', 'Toplam-P']
  },
  {
    index: '68',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Denitrifikasyon, doğru bir reaktör tasarımı, reaksiyon hacminde yüksek F/M oranı ve hızlı bKOI gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '69',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Reaktörde nitrifiye olmuş azot nedeniyle, çöktürme takında yüksek çamur tutma süresi denitrifikasyona ve çamurda gaz hapsi yoluyla köpürmeye neden olabilir, bu da deşarjda AKM kaybına yol açar. Bu durum nihai KOI\'u etkileyebilir. Doğru bir geri dönüşüm kontrolü ve geri dönüşümde REDOX kontrolü bu durumu yönetmeye yardımcı olacaktır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '70',
    typeId: 'atıksu',
    category: ['Koagülasyon', 'Flokülasyon', 'Toplama tankı'],
    text: 'Karıştırma enerjisi nedeniyle köpük oluşabilir. Köpük bastırıcılar önerilir. Silikon bazlı köpük önleyiciler, sentetik filtreleme membranlarıyla uyumlu değildir. Alternatif olarak, alkil hidrokarbonlar içindeki esterler, organik asitlerin tuzları ve yağ asitlerinin tuzları karışımlarına dayalı ticari ürünler kullanılabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Kalıcı Köpük']
  },
  {
    index: '71',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Yeterli koagülant dozajı gereklidir. Kavanoz testi (jar test) kesinlikle tavsiye edilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Sülfür',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Toplam-N',
      'Yağ ve Gres',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Toplam-P',
      'AKM (Askıda Katı Madde)',
      'BOİ5'
    ]
  },
  {
    index: '72',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Yeterli koagülant/metal çöktürücü ajan dozajı gereklidir. Kavanoz testi (jar test) kesinlikle tavsiye edilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Nikel',
      'Gümüş',
      'Cıva',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '73',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Aşırı düşük pH değerleri (< 2-4) kumun dayanımını ve stabilitesini bozacaktır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Kobalt',
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Toplam-N',
      'Toplam Krom',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Nikel',
      'Gümüş',
      'Toplam-P',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Cıva',
      'BOİ5',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '74',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi', 'Basınçlı kum filtresi'],
    text: 'Filtre yıkama sıklığı: günlük olarak tavsiye edilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Bakır',
      'Toplam-N',
      'Kadmiyum',
      'Kobalt',
      'AOX',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Gümüş',
      'Toplam-P',
      'Cıva',
      'Toplam Krom',
      'BOİ5',
      'Kurşun',
      'Çinko',
      'Arsenik',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Nikel'
    ]
  },
  {
    index: '75',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Filtre yıkama sıklığı: günlük olarak önerilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Fenol', 'Toplam-P']
  },
  {
    index: '76',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi', 'Basınçlı kum filtresi'],
    text: 'Filtrasyon medyası biyolojik olarak kontamine olabilir. Programlı dezenfeksiyon yıkamaları önerilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Bakır',
      'Toplam-N',
      'Fenol',
      'Kadmiyum',
      'Kobalt',
      'AOX',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Gümüş',
      'Toplam-P',
      'Cıva',
      'Toplam Krom',
      'BOİ5',
      'Kurşun',
      'Çinko',
      'Arsenik',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Nikel'
    ]
  },
  {
    index: '77',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Filtrasyon medyasının kapasite kontrolü kritik öneme sahiptir. Atıksuda bulunan çözünür ve adsorbe edilebilir AOX referans olarak kullanılmalıdır ve bu değerler filtrenin giriş ve çıkışında periyodik olarak test edilmelidir. Arıtılmış su akış verileri de gereklidir. Bu verileri kullanarak, operatörler filtrenin içindeki kilogram granüler aktif karbon başına adsorbe edilen karakteristik kimyasal parametre miktarını belirlemelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['AOX']
  },
  {
    index: '78',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Filtrasyon medyasının kapasite kontrolü kritik öneme sahiptir. Atıksuda bulunan çözünür ve adsorbe edilebilir BOI5 referans olarak kullanılmalıdır ve bu değerler filtrenin giriş ve çıkışında periyodik olarak test edilmelidir. Arıtılmış su akış verileri de gereklidir. Bu verileri kullanarak, operatörler filtrenin içindeki kilogram granüler aktif karbon başına adsorbe edilen karakteristik kimyasal parametre miktarını belirlemelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '79',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Filtrasyon medyasının kapasite kontrolü kritik öneme sahiptir. Atıksuda bulunan çözünür ve adsorbe edilebilir KOI referans olarak kullanılmalıdır ve bu değerler filtrenin giriş ve çıkışında periyodik olarak test edilmelidir. Arıtılmış su akış verileri de gereklidir. Bu verileri kullanarak operatörler, filtrenin içindeki kilogram granüler aktif karbon başına adsorbe edilen karakteristik kimyasal parametre miktarını belirlemelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '80',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Filtrasyon medyasının kapasite kontrolü kritik öneme sahiptir. Atıksuda bulunan çözünür ve adsorbe edilebilir azot (N) referans olarak kullanılmalıdır ve bu değerler filtrenin giriş ve çıkışında periyodik olarak test edilmelidir. Arıtılmış su akış verileri de gereklidir. Bu verileri kullanarak, operatörler filtrenin içindeki kilogram granüler aktif karbon başına adsorbe edilen karakteristik kimyasal parametre miktarını belirlemelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '81',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Filtrasyon medyasının kapasite kontrolü kritik öneme sahiptir. Atıksuda bulunan çözünür ve adsorbe edilebilir fosfor (P) referans olarak kullanılmalıdır ve bu değerler filtrenin giriş ve çıkışında periyodik olarak test edilmelidir. Arıtılmış su akış verileri de gereklidir. Bu verileri kullanarak, operatörler filtrenin içindeki kilogram granüler aktif karbon başına adsorbe edilen karakteristik kimyasal parametre miktarını belirlemelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '82',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Filtrasyon medyasının kapasite kontrolü kritik öneme sahiptir. Atıksuda bulunan çözünür ve adsorbe edilebilir fenoller referans olarak kullanılmalıdır ve bu değerler filtrenin giriş ve çıkışında periyodik olarak test edilmelidir. Arıtılmış su akış verileri de gereklidir. Bu verileri kullanarak, operatörler filtrenin içindeki kilogram granüler aktif karbon başına adsorbe edilen karakteristik kimyasal parametre miktarını belirlemelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Fenol']
  },
  {
    index: '83',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Filtrasyon medyasının kapasite kontrolü kritik öneme sahiptir. Atıksuda bulunan bazı kimyasal karakteristik parametreler referans olarak kullanılmalıdır ve bu değerler filtrenin giriş ve çıkışında periyodik olarak test edilmelidir. Arıtılmış su akış verileri de gereklidir. Bu verileri kullanarak, operatörler filtrenin içindeki kilogram granüler aktif karbon başına adsorbe edilen karakteristik kimyasal parametre miktarını belirlemelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Kobalt',
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Nikel',
      'Gümüş',
      'Cıva',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '84',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Filtrasyon medyasının ömrü kontrol edilmelidir. Yoğun kullanım durumunda, kumun ömrü 2 ila 3 yıl olarak beklenmektedir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Kobalt',
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Toplam-N',
      'Toplam Krom',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Nikel',
      'Gümüş',
      'Toplam-P',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Cıva',
      'BOİ5',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '85',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Tavsiye edilen filtrasyon hızı: 10 ila 15 m³/saat/m².',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Bakır',
      'Toplam-N',
      'Fenol',
      'Kadmiyum',
      'Kobalt',
      'AOX',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Gümüş',
      'Toplam-P',
      'Cıva',
      'Toplam Krom',
      'BOİ5',
      'Kurşun',
      'Çinko',
      'Arsenik',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Nikel'
    ]
  },
  {
    index: '86',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Tavsiye edilen filtrasyon hızı: 12 ila 18 m³/saat/m².',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Kobalt',
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Toplam-N',
      'Toplam Krom',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Nikel',
      'Gümüş',
      'Toplam-P',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Cıva',
      'BOİ5',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '87',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi', 'Basınçlı kum filtresi'],
    text: 'İnce çökeltilmiş sülfür tozları kum tanelerini kontamine edebilir ve filtrenin girişinde önlenmelidir. Bu nedenle, önceki işlem aşamaları doğru şekilde çalıştırılmalıdır (bkz. Ünite 3: koagülasyon, Ünite 4: flokülasyon, Ünite 5: çökelme).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Sülfür']
  },
  {
    index: '88',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Köpük bastırıcılar önerilir. Silikon bazlı köpük önleyiciler, sentetik filtrasyon membranlarıyla uyumlu değildir. Alternatif olarak, alkil hidrokarbonlar içindeki esterler, organik asitlerin tuzları ve yağ asitlerinin tuzlarından oluşan karışımlara dayalı ticari ürünler kullanılabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Kalıcı Köpük']
  },
  {
    index: '89',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için: Tavsiye edilen Camp sayısı önerilen 20.000-50.000 u\'dur. Not: Camp sayısı (Gt), hız gradyanı (G, s-1) ile hidrolik bekletme süresi (HRT) çarpımından elde edilen üründür. Bu parametre, hızlı karıştırma ve flokülasyon süreçlerinin tasarımında yaygın olarak kullanılır. Kesin Camp sayısı kavanoz testi (jar test) deneyleriyle elde edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '90',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için; Hidrolik yük, net çökelme alanının 1-2 m³/saat/m²\'sinden az olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '91',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için: Hidrolik bekleme süresi (HRT) > 1 saat olmalıdır. Tavsiye edilen süre ise 2 ila 4 saattir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '92',
    typeId: 'atıksu',
    category: ['Koagülasyon', 'Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için: Hidrolik kısa devrelerden kaçınılmalıdır; reaktör girişi, reaktör çıkışından uzak olmalı ve karıştırma sağlanmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '93',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için: Hidrolik kısa devrelerden kaçınılmalıdır; reaktör girişi, reaktör çıkışından uzak olmalıdır. Makul bir çamur girişi ve çamur yayılması sağlanmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '94',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için; Kütle yükü, net çökelme alanının 3 kg/h/m²\'sinden az olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '95',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için:  Karıştırma yoğun olmalıdır. Tavsiye edilen: hız gradyanı > 100 s⁻¹ ve devir > 100 rpm. Reaksiyon havuzu tamamen karışmış olmalı, ölü hacim olmamalıdır. Karıştırma pompalaması > 100 tank hacmi/saat.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '96',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için: Karıştırma hafif olmalıdır. Tavsiye edilen: hız gradyanı < 50 s⁻¹ ve devir < 50 rpm. Reaksiyon havuzu tamamen karıştırılmış olmalı ve ölü hacim olmamalıdır. Karıştırma pompalama kapasitesi > 20 tank hacmi/saat olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '97',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı', 'Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için: Çamur Hacmi İndeksi (SVI) ≤ 150 ml/g olmalıdır. SVI, Aktif Çamur Süreci\'ndeki havalandırma tankındaki çamurun çökelme özelliklerini tanımlamak için kullanılır. SVI, 1 gram aktif çamurun 30 dakika çöktükten sonra kapladığı hacmi (mL cinsinden) ifade eder.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '98',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için: Çöktürme tankı için doğru sıcaklık 30ºC\'nin altında olmalıdır. Bu nedenle, sıcaklığın uygun olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '99',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için: Savak hızı < 4 m³/h/m olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '100',
    typeId: 'atıksu',
    category: ['Koagülasyon', 'Toplama tankı'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için: kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında çalıştırılması önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '101',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan BOI5 için: Çamur ekstraksiyon akışı, çamur seviyesinin temiz su yüzeyinin 1 ila 2 metre altında olmasını garanti etmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '102',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan KOI için; çökelme süreçlerinin 10ºC\'nin üzerinde çalıştırılması önerilir, çünkü viskozitedeki artış, agregaların aşağı doğru hareket hızını azaltır. Bu nedenle, suyun sıcaklığının 10ºC\'nin üzerinde olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '103',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: Tavsiye edilen Camp sayısı önerilen 20.000-50.000 u\'dur. Not: Camp sayısı (Gt), hız gradyanı (G, s-1) ile hidrolik bekletme süresi (HRT) çarpımından elde edilen üründür. Bu parametre, hızlı karıştırma ve flokülasyon süreçlerinin tasarımında yaygın olarak kullanılır. Kesin Camp sayısı kavanoz testi (jar test) deneyleriyle elde edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '104',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: Hidrolik yük, net çökelme alanının 1-2 m³/saat/m²\'sinden az olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '105',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: Hidrolik bekleme süresi (HRT) > 1 saat olmalıdır. Tavsiye edilen süre ise 2 ila 4 saattir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '106',
    typeId: 'atıksu',
    category: ['Koagülasyon', 'Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: Hidrolik kısa devrelerden kaçınılmalıdır; reaktör girişi, reaktör çıkışından uzak olmalı ve karıştırma sağlanmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '107',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: Hidrolik kısa devrelerden kaçınılmalıdır; reaktör girişi, reaktör çıkışından uzak olmalıdır. Makul bir çamur girişi ve çamur yayılması sağlanmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '108',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: Kütle yükü, net çökelme alanının 3 kg/h/m²\'sinden az olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '109',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Katı parçacıklardan kaynaklanan KOI için:  Karıştırma yoğun olmalıdır. Tavsiye edilen: hız gradyanı > 100 s⁻¹ ve devir > 100 rpm. Reaksiyon havuzu tamamen karışmış olmalı, ölü hacim olmamalıdır. Karıştırma pompalaması > 100 tank hacmi/saat.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '110',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: Karıştırma hafif olmalıdır. Karıştırma hafif olmalıdır. Tavsiye edilen: hız gradyanı < 50 s⁻¹ ve devir < 50 rpm. Reaksiyon havuzu tamamen karıştırılmış olmalı ve ölü hacim olmamalıdır. Karıştırma pompalama kapasitesi > 20 tank hacmi/saat olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '111',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı', 'Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: Çamur Hacmi İndeksi (SVI) ≤ 150 ml/g olmalıdır. SVI, Aktif Çamur Süreci\'ndeki havalandırma tankındaki çamurun çökelme özelliklerini tanımlamak için kullanılır. SVI, 1 gram aktif çamurun 30 dakika çöktükten sonra kapladığı hacmi (mL cinsinden) ifade eder.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '112',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: Çöktürme tankı için doğru sıcaklık 30ºC\'nin altında olmalıdır. Bu nedenle, sıcaklığın uygun olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '113',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: Savak hızı < 4 m³/h/m olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '114',
    typeId: 'atıksu',
    category: ['Koagülasyon', 'Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında çalıştırılması önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '115',
    typeId: 'atıksu',
    category: ['Toplama tankı'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında çalıştırılması önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '116',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan KOI için: Çamur ekstraksiyon akışı, çamur seviyesinin temiz su yüzeyinin 1 ila 2 metre altında olmasını garanti etmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '117',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: 'Küme halinde bağlı koliformlar için ince ekranlama yararlı olabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Koliform [bakteri/100 ml]']
  },
  {
    index: '118',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Katı parçacıklardan kaynaklanan Yağ ve Gres için: Karıştırma yoğun olmalıdır. Tavsiye edilen: hız gradyanı > 100 s⁻¹ ve devir > 100 rpm. Reaksiyon havuzu tamamen karışmış olmalı, ölü hacim olmamalıdır. Karıştırma pompalaması > 100 tank hacmi/saat.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Yağ ve Gres']
  },
  {
    index: '119',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Yağ ve Gres için: Çöktürme tankı için doğru sıcaklık 30ºC\'nin altında olmalıdır. Bu nedenle, sıcaklığın uygun olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Yağ ve Gres']
  },
  {
    index: '120',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Toplam Azot İçin: Temas süresi yeterli olmalıdır (HRT) > 15 dakika.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '121',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: Tavsiye edilen Camp sayısı önerilen 20.000-50.000 u\'dur. Not: Camp sayısı (Gt), hız gradyanı (G, s-1) ile hidrolik bekletme süresi (HRT) çarpımından elde edilen üründür. Bu parametre, hızlı karıştırma ve flokülasyon süreçlerinin tasarımında yaygın olarak kullanılır. Kesin Camp sayısı kavanoz testi (jar test) deneyleriyle elde edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '122',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: Hidrolik yük, net çökelme alanının 1-2 m³/saat/m²\'sinden az olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '123',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: Hidrolik bekleme süresi (HRT) > 1 saat olmalıdır. Tavsiye edilen süre ise 2 ila 4 saattir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '124',
    typeId: 'atıksu',
    category: ['Koagülasyon', 'Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: Hidrolik kısa devrelerden kaçınılmalıdır; reaktör girişi, reaktör çıkışından uzak olmalı ve karıştırma sağlanmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '125',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: Hidrolik kısa devrelerden kaçınılmalıdır; reaktör girişi, reaktör çıkışından uzak olmalıdır. Makul bir çamur girişi ve çamur yayılması sağlanmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '126',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: Kütle yükü, net çökelme alanının 3 kg/h/m²\'sinden az olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '127',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için:  Karıştırma yoğun olmalıdır. Tavsiye edilen: hız gradyanı > 100 s⁻¹ ve devir > 100 rpm. Reaksiyon havuzu tamamen karışmış olmalı, ölü hacim olmamalıdır. Karıştırma pompalaması > 100 tank hacmi/saat.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '128',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: Karıştırma hafif olmalıdır. Tavsiye edilen: hız gradyanı < 50 s⁻¹ ve devir < 50 rpm. Reaksiyon havuzu tamamen karıştırılmış olmalı ve ölü hacim olmamalıdır. Karıştırma pompalama kapasitesi > 20 tank hacmi/saat olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '129',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: çökelme süreçlerinin 10ºC\'nin üzerinde çalıştırılması önerilir, çünkü viskozitedeki artış, agregaların aşağı doğru hareket hızını azaltır. Bu nedenle, suyun sıcaklığının 10ºC\'nin üzerinde olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '130',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı', 'Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: Çamur Hacmi İndeksi (SVI) ≤ 150 ml/g olmalıdır. SVI, Aktif Çamur Süreci\'ndeki havalandırma tankındaki çamurun çökelme özelliklerini tanımlamak için kullanılır. SVI, 1 gram aktif çamurun 30 dakika çöktükten sonra kapladığı hacmi (mL cinsinden) ifade eder.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '131',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: Çöktürme tankı için doğru sıcaklık 30ºC\'nin altında olmalıdır. Bu nedenle, sıcaklığın uygun olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '132',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: Savak hızı < 4 m³/h/m olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '133',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: Çamur ekstraksiyon akışı, çamur seviyesinin temiz su yüzeyinin 1 ila 2 metre altında olmasını garanti etmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '134',
    typeId: 'atıksu',
    category: ['Koagülasyon', 'Flokülasyon'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: Kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında çalıştırılması önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '135',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Yüksek % BOI5 azaltımı için düşük F/M tasarım değerlerine ihtiyaç vardır.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '136',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Yüksek konsantrasyonlar için, koagülasyon işlemi öncesinde toz halinde aktif karbon kullanılması tavsiye edilir.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Kobalt',
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Toplam-N',
      'Toplam Krom',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Nikel',
      'Gümüş',
      'Toplam-P',
      'Chrom (VI)',
      'Cıva',
      'BOİ5',
      'Kurşun',
      'Fenol',
      'Kadmiyum'
    ]
  },
  {
    index: '137',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Çözünmeyen boyalar için, yüksek güçlü flokülantlar önerilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '138',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Çözünmeyen boyalar için, Al hidroksitlerin adsorpsiyon kapasitesi nedeniyle Al poliklorür gibi alüminyum bazlı koagülantlar tavsiye edilir.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '139',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Ortofosfat azaltımı için, yeni biyolojik çamura kısmi P dahil edilecek, ancak kimyasal kontrol yardımcı olabilir.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '140',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Ortofosfat için: Hidrolik yük, net çökelme alanının 1-2 m³/saat/m²\'sinden az olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '141',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Ortofosfat için: Hidrolik bekleme süresi (HRT) > 1 saat olmalıdır. Tavsiye edilen süre ise 2 ila 4 saattir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '142',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı arçacıklardan kaynaklanan Ortofosfat için: Hidrolik kısa devrelerden kaçınılmalıdır; reaktör girişi, reaktör çıkışından uzak olmalıdır. Makul bir çamur girişi ve çamur yayılması sağlanmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '143',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Ortofosfat için: Kütle yükü, net çökelme alanının 3 kg/h/m²\'sinden az olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '144',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Ortofosfat için: Çöktürme tankı için doğru sıcaklık 30ºC\'nin altında olmalıdır. Bu nedenle, sıcaklığın uygun olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '145',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Ortofosfat için: Savak hızı < 4 m³/h/m olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '146',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Katı parçacıklardan kaynaklanan Ortofosfat için: Çamur ekstraksiyon akışı, çamur seviyesinin temiz su yüzeyinin 1 ila 2 metre altında olmasını garanti etmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '147',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Ortofosfat çökelmesi için, dozaj noktasında çok yüksek karıştırma yoğunluğu (G değerleri 200 ile 300 saniye⁻¹ arasında) tavsiye edilir. Yüksek enerji ile karıştırma süreleri genellikle 10 ila 30 saniye aralığındadır. Bu karıştırma işleminden sonra mevcut koagülasyon uygulanmalıdır. Reaksiyon havuzu tamamen karışmış olmalı, ölü hacim olmamalıdır. Karıştırma pompalaması > 100 tank hacmi/saat olmalıdır.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '148',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Ortofosfat çökelmesi için: Tavsiye edilen Camp sayısı önerilen 20.000-50.000 u\'dur. Not: Camp sayısı (Gt), hız gradyanı (G, s-1) ile hidrolik bekletme süresi (HRT) çarpımından elde edilen üründür. Bu parametre, hızlı karıştırma ve flokülasyon süreçlerinin tasarımında yaygın olarak kullanılır. Kesin Camp sayısı kavanoz testi (jar test) deneyleriyle elde edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '149',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Ortofosfat çökelmesi için: Hidrolik kısa devrelerden kaçınılmalıdır; reaktör girişi, reaktör çıkışından uzak olmalı ve karıştırma sağlanmalıdır. ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '150',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Ortofosfat çökelmesi için: Karıştırma hafif olmalıdır. Tavsiye edilen: hız gradyanı < 50 s⁻¹ ve devir < 50 rpm. Reaksiyon havuzu tamamen karıştırılmış olmalı ve ölü hacim olmamalıdır. Karıştırma pompalama kapasitesi > 20 tank hacmi/saat olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '151',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı', 'Flokülasyon'],
    text: 'Ortofosfat çökelmesi için: Çamur Hacmi İndeksi (SVI) ≤ 150 ml/g olmalıdır. SVI, Aktif Çamur Süreci\'ndeki havalandırma tankındaki çamurun çökelme özelliklerini tanımlamak için kullanılır. SVI, 1 gram aktif çamurun 30 dakika çöktükten sonra kapladığı hacmi (mL cinsinden) ifade eder.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '152',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Katı Parçacıklardan Kaynaklanan Ortofosfat İçin: Hidrolik kısa devrelerden kaçınılmalıdır; reaktör girişi, reaktör çıkışından uzak olmalı ve karıştırma sağlanmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '153',
    typeId: 'atıksu',
    category: ['Toplama tankı'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Azot için: kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında çalıştırılması önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '154',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Katı parçacıklardan kaynaklanan Toplam Fosfor için: kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında çalıştırılması önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '155',
    typeId: 'atıksu',
    category: ['Toplama tankı'],
    text: 'Katı parçacıklardan kaynaklanan toplam Fosfor için: kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında çalıştırılması önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '156',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Tane boyutu, gözenek boyutu ve karbon türü filtre üreticisi tavsiyelerine göre seçilmelidir. Su bileşiminizin değişip değişmediğini ve karbon türü veya tane boyutunu değiştirmeniz gerekip gerekmediğini kontrol edin. Unutmayın ki polar ve düşük moleküler ağırlıklı maddeler aktif karbon gözeneklerinde zayıf bir şekilde tutulur.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '157',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Halojenli çözünebilen maddeler, düşük konsantrasyonlarda aktif karbona adsorbe edilir. Yüksek konsantrasyonlar için, koagülasyon reaksiyonu öncesinde toz halinde aktif karbon kullanılması tavsiye edilir.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['AOX']
  },
  {
    index: '158',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Ağır metal izleri aktif karbon taneciklerine adsorbe edilebilir. Mineral aktif karbon tavsiye edilir. Bu, aktif karbon kullanımının bir yan işlevi olarak düşünülmeli, ancak gerçek bir arıtma yolu olarak düşünülmemelidir. İyonlar, karbon adsorpsiyonu için uygun değildir. Asidik ortam, adsorpsiyonu artırır (pH 4 ila 6 arası).  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Kobalt',
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Nikel',
      'Gümüş',
      'Cıva',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '159',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Yüksek iletkenlik/tuzluluk, aktif çamur performansını bozacak ve dolayısıyla BOI5 performansını etkileyebilir. Reaktör girişindeki klorürler <10.000 ppm ve sülfatlar <1.000 ppm olmalıdır.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '160',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Yüksek iletkenlik/tuzluluk, aktif çamur performansını bozacak ve dolayısıyla KOİ performansını etkileyebilir. Reaktör girişindeki klorürler <10.000 ppm ve sülfatlar <1.000 ppm olmalıdır.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '161',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Yüksek iletkenlik/tuzluluk, aktif çamur performansını bozacak ve dolayısıyla toplam fosfor performansını etkileyebilir. Reaktör girişindeki klorürler <10.000 ppm ve sülfatlar <1.000 ppm olmalıdır.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '162',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Yüksek iletkenlik/tuzluluk, aktif çamur performansını bozacak ve dolayısıyla toplam azot performansını etkileyebilir. Reaktör girişindeki klorürler <10.000 ppm ve sülfatlar <1.000 ppm olmalıdır.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '163',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Yüksek moleküler ağırlıklı kimyasallar, düşük moleküler ağırlıklı maddelere göre daha iyi tutulur.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)', 'BOİ5']
  },
  {
    index: '164',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Yüksek moleküler ağırlıklı azot kimyasalları, düşük moleküler ağırlıklı maddelere göre daha iyi tutulur. Amonyak gibi düşük moleküler ağırlıklı maddeler, aktif karbon filtrelerinde adsorbe edilmez.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '165',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Yüksek moleküler ağırlıklı fosfor kimyasalları, düşük moleküler ağırlıklı maddelere göre daha iyi tutulur. Ortofosfatlar gibi düşük moleküler ağırlıklı maddeler, aktif karbon filtrelerinde adsorbe edilmez.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '166',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Yüksek sıcaklıklar (>25ºC), aktif çamur çökmesini bozacak ve filamentli Nocardioforms gibi çökmeyen bakterileri teşvik edecektir. Bu nedenle, suyun sıcaklığının doğru olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)', 'Sıcaklık']
  },
  {
    index: '167',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Yüksek sıcaklıklar (>25ºC), aktif çamur çökmesini bozacak ve filamentli Nocardioforms gibi çökmeyen bakterileri teşvik edecektir. Bu nedenle, çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla BOI5 uyumsuzluğunu) önlemek için suyun sıcaklığının doğru olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '168',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Yüksek sıcaklıklar (>25ºC), aktif çamur çökmesini bozacak ve filamentli Nocardioforms gibi çökmeyen bakterileri teşvik edecektir. Bu nedenle, çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Azot uyumsuzluğunu) önlemek için suyun sıcaklığının doğru olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '169',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Yüksek sıcaklıklar (>25ºC), aktif çamur çökmesini bozacak ve filamentli Nocardioforms gibi çökmeyen bakterileri teşvik edecektir. Bu nedenle, çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Fosfor uyumsuzluğunu) önlemek için suyun sıcaklığının doğru olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '170',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Yüksek sıcaklıklar (>25ºC), aktif çamur çökmesini bozacak ve filamentli Nocardioforms gibi çökmeyen bakterileri teşvik edecektir. Bu nedenle, çöktürme tankı çıkışında AKM kaybını önlemek için suyun sıcaklığının doğru olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '171',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Hidrolik yük, net çökelme alanının 1-2 m³/saat/m²\'sinden az olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Sülfür',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Yağ ve Gres',
      'Nikel',
      'Gümüş',
      'Cıva',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '172',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Hidrolik bekleme süresi (HRT) > 1 saat olmalıdır. Tavsiye edilen süre ise 2 ila 4 saattir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Sülfür',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Yağ ve Gres',
      'Nikel',
      'Gümüş',
      'Cıva',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '173',
    typeId: 'atıksu',
    category: ['Koagülasyon', 'Flokülasyon', 'Toplama tankı'],
    text: 'Hidrolik kısa devrelerden kaçınılmalıdır; reaktör girişi, reaktör çıkışından uzak olmalı ve karıştırma sağlanmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Bakır',
      'Toplam-N',
      'Kadmiyum',
      'Kobalt',
      'Yağ ve Gres',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Gümüş',
      'Toplam-P',
      'Cıva',
      'Toplam Krom',
      'BOİ5',
      'Kurşun',
      'Çinko',
      'Arsenik',
      'pH',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Sülfür',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Nikel'
    ]
  },
  {
    index: '174',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Hidrolik kısa devrelerden kaçınılmalıdır; reaktör girişi, reaktör çıkışından uzak olmalıdır. Makul bir çamur girişi ve çamur yayılması sağlanmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Sülfür',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Yağ ve Gres',
      'Nikel',
      'Gümüş',
      'Cıva',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '175',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'İletkenlik artarsa, pH ayarlaması için alternatif bir reaktif madde kullanılabilir. Yüksek iletkenlik/tuzluluk, aktif çamur performansını bozacaktır. Reaktör girişindeki klorürler <10.000 ppm ve sülfatlar <1.000 ppm olmalıdır. Ayrıca, ani iletkenlik değişiklikleri, reaktörde etkilere neden olur. Homojenizasyon ve konsantrasyon dengesi, reaktör performansı için önemlidir.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['İletkenlik']
  },
  {
    index: '176',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'İletkenlik artarsa, pH ayarlaması için alternatif bir reaktif madde kullanılabilir. Yüksek iletkenlik/tuzluluk, aktif çamur performansını bozacaktır. Reaktör girişindeki klorürler <10.000 ppm ve sülfatlar <1.000 ppm olmalıdır. Ayrıca, ani iletkenlik değişiklikleri, reaktör/ikincil çökelme üzerinde etkilere neden olur. Homojenizasyon ve konsantrasyon dengesi, reaktör ve ikincil çökelme performansı için önemlidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['İletkenlik']
  },
  {
    index: '177',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Metallerin çökelmesi zor olduğunda, özel organosülfürlerin çökelme artırıcı olarak kullanılması gerekmektedir.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Arsenik',
      'Antimon',
      'Nikel',
      'Gümüş',
      'Cıva',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '178',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'pH artarsa/azalırsa, pH ayarlaması için alternatif bir reaktif madde kullanılabilir. Biyolojik reaktörde düşük veya yüksek pH, çamur çökelme hızını ve kalitesini olumsuz etkiler. Doğru pH aralığı 7,2 ila 8,2\'dir. Düşük pH, bazik bir reaktif (örneğin kostik soda) eklenmesini gerektirirken, yüksek pH, asidik bir reaktif (örneğin sülfürik asit veya hidroklorik asit) eklenmesini gerektirir.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['pH']
  },
  {
    index: '179',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'pH artarsa/azalırsa, pH ayarlaması için alternatif bir reaktif madde kullanılabilir. Biyolojik reaktörde pH aralığı 7,2 ila 8,2 arasında olmalıdır. Genellikle pH düzeltmesi gereklidir. Düşük pH, bazik bir reaktif (örneğin kostik soda) eklenmesini gerektirirken, yüksek pH, asidik bir reaktif (örneğin sülfürik asit veya hidroklorik asit) eklenmesini gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['pH']
  },
  {
    index: '180',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çamur iyi çökelmezse, bu, arıtma sırasında AKM oluşumuna neden olabilir ve dolayısıyla KOI uyumsuzluğuna yol açabilir. KOI uyumsuzluğunu önlemek için sürecin yakından kontrolü zorunludur, özellikle V30\' ve SVI reaktör kontrolü. Ayrıca, inhibitörler KOI, çöktürme takında performansında ciddi aksamalara neden olabilir.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '181',
    typeId: 'atıksu',
    category: ['Toplama tankı'],
    text: 'pH değişken akışları durumunda pH probu önerilir ve PID kontrolü için pH değeri kullanılmalıdır. pH artarsa, asidik bir reaktif gerekir; pH azalırsa, bazik bir reaktif gerekir.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['pH']
  },
  {
    index: '182',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Sıcaklığın doğru olup olduğu kontrol edilmelidir. Biyolojik reaktörde mevcut işlem sıcaklığı 16 ila 22ºC aralığını kapsar, 18-20ºC önerilen aralıktır. Düşük sıcaklıklar < 16ºC biyolojik süreci dramatik şekilde yavaşlatır, bu nedenle biyolojik reaktöre girmeden önce atık suyu ısıtmak için bir ısı değiştirici veya ısı pompası gerekebilir. Öte yandan, 25 ila 30ºC arasındaki sıcaklıklar nitrifikasyonu etkiler ve >30-35ºC\'de nitrifikasyon mümkün olmayacaktır.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Sıcaklık']
  },
  {
    index: '183',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Kurşun, soda külü eklenerek 9,0 - 9,5 pH\'da karbonat olarak çökeltilir. Diğer bir alternatif ise, pH 11,5\'te kireç ile çökelmedir.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Kurşun']
  },
  {
    index: '184',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Kurşun kompleksleşemez. Bu, kompleks oluşturamayacakları anlamına gelir. Metal kompleksi, bir veya daha fazla metal atomunun bir veya daha fazla ligand ile bağlandığı bir bileşiktir. Ligand, bir veya daha fazla atom üzerinden bir metal merkeze bağlanabilen organik bir bileşiktir. Bu nedenle, metalin fizikokimyasal işlemle uzaklaştırılabilmesi için serbest olması gerekir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Kurşun']
  },
  {
    index: '185',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Kurşun konsantrasyonları > 1,0 ila 5 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Kurşun']
  },
  {
    index: '186',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çamur veya işlenmiş atıksulardan kaynaklanan AKM kaybı, deşarjdaki Toplam Fosfor değerlerini artırır. Bu nedenle, deşarjdaki katı madde kontrolü kritik öneme sahiptir. Katıların sızıntısından dolayı Toplam Fosfor uyumsuzluğunu önlemek için sürecin yakından kontrolü zorunludur, özellikle V30\' ve SVI reaktör kontrolü.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '187',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çamur veya işlenmiş atıksulardan kaynaklanan AKM kaybı, deşarjdaki Toplam Azot değerlerini artırır. Bu nedenle, deşarjdaki katı madde kontrolü kritik öneme sahiptir. Katıların sızıntısından dolayı Toplam Azot uyumsuzluğunu önlemek için sürecin yakından kontrolü zorunludur, özellikle V30\' ve SVI reaktör kontrolü.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '188',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çamur veya işlenmiş atıksulardan kaynaklanan AKM kaybı, deşarjdaki BOI5 değerlerini artırır. Bu nedenle, deşarjdaki katı madde kontrolü kritik öneme sahiptir. Katıların sızıntısından dolayı BOI5 uyumsuzluğunu önlemek için sürecin yakından kontrolü zorunludur, özellikle V30\' ve SVI reaktör kontrolü.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '189',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çamur veya işlenmiş atıksulardan kaynaklanan AKM kaybı, deşarjdaki KOI değerlerini artırır.  Bu nedenle, deşarjdaki katı madde kontrolü kritik öneme sahiptir (V30\' ölçümleri ve SVI\'nin < 150 ml/g değerlerinde tutulması gereklidir). KOI uyumsuzluğunun katı sızıntısından kaynaklanıp kaynaklanmadığını belirlemek için, AKM\'nin ikincil çökelti çıkış suyunda analiz edilmesi gerekir ve ardından şu ifadeyi uygulayın: AKM nedeniyle teorik KOI, 1,46 x AKM sonucu (ppm) eşittir. Yani, ikincil çökelti çıkış suyundaki gerçek KOI (katı sızıntısı yoksa) = KOI (ppm) sonucu - AKM\'ye bağlı teorik KOI.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '190',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: 'Kanallarda düşük karıştırma hava-sıvı enerjisi önerilir.  ',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Kalıcı Köpük']
  },
  {
    index: '191',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Düşük sıcaklıklar, viskozitedeki artış nedeniyle filtrasyon hızını biraz azaltır. Aksine, yüksek sıcaklıklar filtrasyon hızını artırır. Filtre kapasitesi, çok düşük veya çok yüksek sıcaklıklar için tasarlanmalıdır. Mevcut sıcaklık aralığında (10 ila 30ºC arasında) etkisi beklenmemektedir. Bu nedenle, suyun sıcaklığının doğru olup olduğu kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam Krom', 'Arsenik']
  },
  {
    index: '192',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Düşük sıcaklıklar, viskozitedeki artış nedeniyle filtrasyon hızını biraz azaltır. Aksine, yüksek sıcaklıklar filtrasyon hızını artırır. Filtre kapasitesi, çok düşük veya çok yüksek sıcaklıklar için tasarlanmalıdır. Mevcut sıcaklık aralığında (10 ila 30ºC arasında) etkisi beklenmemektedir. Bu nedenle, suyun sıcaklığının doğru olup olduğu kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Kobalt',
      'Çinko',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Toplam-N',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Nikel',
      'Gümüş',
      'Toplam-P',
      'Chrom (VI)',
      'Cıva',
      'BOİ5',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '193',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Düşük sıcaklıklar, viskozitedeki artış nedeniyle filtrasyon hızını biraz azaltır. Aksine, yüksek sıcaklıklar filtrasyon hızını artırır. Filtre kapasitesi, çok düşük veya çok yüksek sıcaklıklar için tasarlanmalıdır. Mevcut sıcaklık aralığında (10 ila 30ºC arasında) etkisi beklenmemektedir. Bu nedenle, suyun sıcaklığının doğru olup olduğu kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '194',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Kütle yükü, net çökelme alanının 3 kg/h/m²\'sinden az olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Sülfür',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Yağ ve Gres',
      'Nikel',
      'Gümüş',
      'Cıva',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '195',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Cıva 1+ organosülfür çökelmesi veya demir(III) hidroksit koçökelmesi kullanılarak çökeltilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Cıva']
  },
  {
    index: '196',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Cıva kompleksleşemez. Bu, kompleks oluşturamayacakları anlamına gelir. Metal kompleksi, bir veya daha fazla metal atomunun bir veya daha fazla ligand ile bağlandığı bir bileşiktir. Ligand, bir veya daha fazla atom üzerinden bir metal merkeze bağlanabilen organik bir bileşiktir. Bu nedenle, metalin fizikokimyasal işlemle uzaklaştırılabilmesi için serbest olması gerekir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Cıva']
  },
  {
    index: '197',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Cıva, konsantrasyonları > 0,1 ila 1 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve çöktürme tankı girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Cıva']
  },
  {
    index: '198',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Karıştırma, saatlik atıksu akışlarını kullanarak nötralizasyona yardımcı olabilir. Karıştırma enerji yoğunluğu > 35 W/m³ önerilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Cıva']
  },
  {
    index: '199',
    typeId: 'atıksu',
    category: ['Toplama tankı'],
    text: 'Karışım, saatlik atık su akışlarını kullanarak nötralizasyona yardımcı olabilir. Karışım enerji yoğunluğu > 35 W/m³ olarak önerilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['pH']
  },
  {
    index: '200',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Karıştırma yoğun olmalıdır. Tavsiye edilen: hız gradyanı > 100 s⁻¹ ve devir > 100 rpm. Reaksiyon havuzu tamamen karışmış olmalı, ölü hacim olmamalıdır. Karıştırma pompalaması > 100 tank hacmi/saat.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Sülfür', 'AKM (Askıda Katı Madde)']
  },
  {
    index: '201',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Karıştırma yoğun olmalıdır. Tavsiye edilen: hız gradyanı > 100 s⁻¹ ve devir > 100 rpm. Reaksiyon havuzu tamamen karışmış olmalı, ölü hacim olmamalıdır. Karıştırma pompalaması > 100 tank hacmi/saat.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)', 'pH']
  },
  {
    index: '202',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Karıştırma hafif olmalıdır. Tavsiye edilen: hız gradyanı < 50 s⁻¹ ve devir < 50 rpm. Reaksiyon havuzu tamamen karıştırılmış olmalı ve ölü hacim olmamalıdır. Karıştırma pompalama kapasitesi > 20 tank hacmi/saat olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)', 'AKM (Askıda Katı Madde)', 'Sülfür']
  },
  {
    index: '203',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Karıştırma hafif olmalıdır. Tavsiye edilen: hız gradyanı < 50 s⁻¹ ve devir < 50 rpm. Reaksiyon havuzu tamamen karıştırılmış olmalı ve ölü hacim olmamalıdır. Karıştırma pompalama kapasitesi > 20 tank hacmi/saat olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Yağ ve Gres',
      'Nikel',
      'Gümüş',
      'Cıva',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '204',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Nötralizasyon kimyasalı dikkatlice dozlanmalıdır, özellikle düşük alkaliniteye sahip atık sularla. Bu durumda, yumuşak veya hafif nötralizasyon kimyasalı kullanılabilir. Örneğin: CO₂ asidik ajan / Ca(OH)₂ veya Na₂CO₃.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['pH']
  },
  {
    index: '205',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Nikel, pH 10 - 11 aralığında kireç kullanılarak hidroksit olarak çöktürülebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Nikel']
  },
  {
    index: '206',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Nikel kompleksleşemez. Bu, kompleks oluşturamayacakları anlamına gelir. Metal kompleksi, bir veya daha fazla metal atomunun bir veya daha fazla ligand ile bağlandığı bir bileşiktir. Ligand, bir veya daha fazla atom üzerinden bir metal merkeze bağlanabilen organik bir bileşiktir. Bu nedenle, metalin fizikokimyasal işlemle uzaklaştırılabilmesi için serbest olması gerekir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Nikel']
  },
  {
    index: '207',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Nikel, konsantrasyonları > 1,0 ila 2,5 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Nikel']
  },
  {
    index: '208',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Nitrifikasyon, nispeten yüksek bir çamur yaşı (>15 gün, reaktör sıcaklık aralığına bağlı olarak) ve reaktör sıcaklığı >15ºC ve <25ºC arasında olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '209',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Nitrojen non-polar ve yüksek moleküler ağırlığa sahip kimyasal bileşiklerin (örneğin triazitler), aktif karbon gözeneklerinde tutulması beklenir. Ticari aktif karbonun gözenek boyut dağılımı, tutulması gereken kimyasal bileşik özelliklerine göre seçilmelidir. Aksine, polar ve düşük moleküler ağırlığa sahip maddeler (örneğin amonyak) aktif karbon gözeneklerinde zayıf bir şekilde tutulur.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '210',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir (yağ ve gres çözünür değildir ve biyolojik olarak parçalanmaz). Reaktör girişinde önlenmelidir. Yağ ve gres biyolojik olarak parçalanamaz çünkü çözünür değildir ve aktif çamurda ciddi işlev bozukluklarına neden olabilir, örneğin zayıf oksijen transferi ve filamentöz gibi çökmeyen bakterilerin varlığı.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Yağ ve Gres']
  },
  {
    index: '211',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir (fenoller biyolojik olarak toksiktir ve biyolojik reaktör girişinde önlenmelidir). Inhibisyon seviyeleri 50 ila 200 ppm arasında gözlemlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Fenol']
  },
  {
    index: '212',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Bu birimde sıcaklık azaltma/ artırma için herhangi bir eylem beklenmemektedir. Ancak: aktif karbonun kapasitesi sıcaklık arttıkça azalır. Çok yüksek sıcaklıklarda, adsorpsiyon kapasitesinde bir azalma beklenir. Mevcut sıcaklık aralığı (10 ila 30ºC) için herhangi bir etki beklenmemektedir. Bu nedenle, suyun sıcaklığının doğru olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Sıcaklık']
  },
  {
    index: '213',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Bu birimde sıcaklık azaltma/ artırma için herhangi bir eylem beklenmemektedir. Ancak: düşük sıcaklıklar, viskozitedeki artış nedeniyle filtrasyon hızını biraz azaltır. Aksine, yüksek sıcaklıklar filtrasyon hızını artırır. Filtre kapasitesi, çok düşük veya çok yüksek sıcaklıklar için tasarlanmalıdır. Mevcut sıcaklık aralığında (10 ila 30ºC arasında) etkisi beklenmemektedir. Bu nedenle, suyun sıcaklığının doğru olup olduğu kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Sıcaklık']
  },
  {
    index: '214',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Bu birimde sıcaklık azaltma/ artırma için herhangi bir eylem beklenmemektedir. Ancak: çökelme süreçlerinin 10ºC\'nin üzerinde çalıştırılması önerilir, çünkü viskozitedeki artış, agregaların aşağı doğru hareket hızını azaltır. Bu nedenle, suyun sıcaklığının 10ºC\'nin üzerinde olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Sıcaklık']
  },
  {
    index: '215',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Bu birimde sıcaklık azaltma/ artırma için herhangi bir eylem beklenmemektedir. Ancak: kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında işletilmesi önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Sıcaklık']
  },
  {
    index: '216',
    typeId: 'atıksu',
    category: ['Koagülasyon', 'Toplama tankı'],
    text: 'Bu birimde sıcaklık azaltma/ artırma için herhangi bir eylem beklenmemektedir. Ancak: kimyasal koagülasyon ve flokülasyon süreçlerinin 30ºC\'nin altında çalıştırılması önerilir. Bu nedenle, koagülasyon reaktörüne (toplama tankında) girmeden önce suyun sıcaklığının 30ºC\'nin altında olup olmadığı kontrol edilmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Sıcaklık']
  },
  {
    index: '217',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Krom 6+, konsantrasyonları > 1 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Chrom (VI)']
  },
  {
    index: '218',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Antimon aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikiminden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Antimon']
  },
  {
    index: '219',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Arsenik, konsantrasyonları > 0,1 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikiminden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Arsenik']
  },
  {
    index: '220',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Kadmiyum, konsantrasyonları > 1 ila 10 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikiminden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Kadmiyum']
  },
  {
    index: '221',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Kobalt, aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Kobalt']
  },
  {
    index: '222',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Koliformlar, havalandırmalı reaktörde azalır ancak ortadan kaldırılmaz veya kontrol edilmez. Her halükarda, havalandırmalı biyolojik arıtma bir koliform arıtma prosedürü değildir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Koliform [bakteri/100 ml]']
  },
  {
    index: '223',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Bakır, konsantrasyonları  > 1,0 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Bakır']
  },
  {
    index: '224',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Siyanürler biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Siyanür inhibitör seviyesi 30 ppm’dir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Siyanür - toplam']
  },
  {
    index: '225',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Herhangi bir eylem beklenmemektedir. Siyanürler aktif çamurda flokülasyon kaybına ve kötü çökmeye neden olabilir. Siyanürler biyolojik reaktör girişinde önlenmelidir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Siyanür - toplam']
  },
  {
    index: '226',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Herhangi bir eylem beklenmemektedir. Yağ ve gres, reaktör ve ikincil çökelme girişinde kaçınılmalıdır. Yağ ve gres, çamur yoğunluğunu azaltır ve çamur çökme kalitesine ciddi zararlar verebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Yağ ve Gres']
  },
  {
    index: '227',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Kurşun konsantrasyonları > 1,0 ila 5 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Kurşun']
  },
  {
    index: '228',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Cıva, konsantrasyonları > 0,1 ila 1 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Cıva']
  },
  {
    index: '229',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Nikel, konsantrasyonları > 1,0 ila 2,5 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Nikel']
  },
  {
    index: '230',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi', 'Basınçlı kum filtresi'],
    text: 'Herhangi bir eylem beklenmemektedir. Çözünmeyen veya yağlı maddeler filtreleme medyasını ciddi şekilde kirletebilir. Bu maddeler filtre girişinde bulunmamalıdır. Bunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Yağ ve Gres']
  },
  {
    index: '231',
    typeId: 'atıksu',
    category: ['Toplama tankı'],
    text: 'Herhangi bir eylem beklenmemektedir. Yağ ve gresin toplama tankına girmesi önerilmez. Tercihen, homojenizasyon öncesinde ayrılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Yağ ve Gres']
  },
  {
    index: '232',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Herhangi bir eylem beklenmemektedir. Fenoller, WW deşarjında flokülasyon kaybına ve AKM kaybına neden olabilir, bu da KOI/BOI5/Nt/Pt deşarj kalitesini etkiler. Biyolojik reaktör girişinde kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Fenol']
  },
  {
    index: '233',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Gümüş aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikiminden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Gümüş']
  },
  {
    index: '234',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Herhangi bir eylem beklenmemektedir. Yüksek kaliteli çökelme ve düşük deşarj bulanıklığı elde edildiğinde bazı koliformların azalması beklenebilir. Ancak, çökelme bir koliform arıtma prosedürü değildir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Koliform [bakteri/100 ml]']
  },
  {
    index: '235',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Herhangi bir eylem beklenmemektedir. Sülfür aktif çamurda flokülasyon kaybına ve kötü çökmeye neden olabilir. Sülfürler biyolojik reaktör girişinde önlenmelidir. Bunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Sülfür']
  },
  {
    index: '236',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Toplam Krom, konsantrasyonları > 1 ila 100 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam Krom']
  },
  {
    index: '237',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Herhangi bir eylem beklenmemektedir. Çinko, konsantrasyonları > 0,3 ila 5 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Çinko']
  },
  {
    index: '238',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Biyodegradabl olmayan azot veya nitrifikasyon/denitrifikasyon teknolojisindeki eksiklik, reaktör ve çöktürme takında Toplam Azot konsantrasyonlarına neden olacaktır. Öte yandan, çamur veya işlenmiş atıksulardan kaynaklanan AKM kaybı, deşarjdaki Nt değerlerini artırır. Bu nedenle, deşarjdaki katı madde kontrolü kritik öneme sahiptir (AKM parametresi için eylemlere bakınız).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '239',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Non-polar ve yüksek moleküler ağırlığa sahip kimyasal bileşiklerin (örneğin, Poliklitik Aromatik Hidrokarbonlar (PAH\'lar), benzo-a-piren gibi) aktif karbon gözeneklerinde tutulması beklenir. Ticari aktif karbonun gözenek boyutu dağılımı, tutulacak kimyasal bileşiklerin özelliklerine göre seçilmelidir. Aksine, polar ve düşük moleküler ağırlığa sahip maddeler (örneğin, formaldehit) aktif karbon gözeneklerinde zayıf bir şekilde tutulur.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '240',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Non-polar ve yüksek moleküler ağırlığa sahip kimyasal bileşiklerin (örneğin, non-polar uzun zincirli lipidler, asit gliseroller gibi) aktif karbon gözeneklerinde tutulması beklenir. Ticari aktif karbonun gözenek boyutu dağılımı, tutulacak kimyasal bileşiklerin özelliklerine göre seçilmelidir. Aksine, polar ve düşük moleküler ağırlığa sahip maddeler (örneğin, metanol) aktif karbon gözeneklerinde zayıf bir şekilde tutulur.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '241',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Non-polar ve yüksek moleküler ağırlığa sahip kimyasal bileşiklerin (örneğin, paration) aktif karbon gözeneklerinde tutulması beklenir. Ticari aktif karbonun gözenek boyutu dağılımı, tutulacak kimyasal bileşiklerin özelliklerine göre seçilmelidir. Aksine, polar ve düşük moleküler ağırlığa sahip maddeler (örneğin, fosfor triklorür) aktif karbon gözeneklerinde zayıf bir şekilde tutulur.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '242',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Çözünmeyen BOI5\'in ACF filtre girişinde bulunmaması gerekir çünkü bu, filtreleme medyasının kirlenmesine neden olur. Kirlenmenin varlığı ortadan kaldırılmalıdır. Filtreleme ortamının kirlenmesi durumunda, bu birim iyi çalışmayacak ve BOI5’de olası uyumsuzluklara neden olabilir. Bu nedenle, çözünmeyen BOI5\'in ACF filtre girişine girmesini önlemek için önceki koagülasyon + flokülasyon + kum filtre birimleri iyi çalıştırılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '243',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Çözünmeyen BOI5\'in, partikül boyutu 20-50 mikron arasında ve kullanılan tane boyutu üretici tavsiyelerine göre olduğunda kum filtrasyonu sırasında tutulması beklenir. Bu nedenle, aşağıdaki durumlar kontrol edilmelidir: toplam BOI5 ile çözünür BOI5 arasındaki ilişki, kullanılan tane boyutu.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '244',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Çözünmeyen KOI\'in ACF filtre girişinde bulunmaması gerekir çünkü bu, filtreleme medyasının kirlenmesine neden olur. Kirlenmenin varlığı ortadan kaldırılmalıdır. Filtreleme ortamının kirlenmesi durumunda, bu birim iyi çalışmayacak ve KOI’de olası uyumsuzluklara neden olabilir. Bu nedenle, çözünmeyen KOI\'in ACF filtre girişine girmesini önlemek için önceki koagülasyon + flokülasyon + kum filtre birimleri iyi çalıştırılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '245',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Çözünmeyen KOI\'in, partikül boyutu 20-50 mikron arasında ve kullanılan tane boyutu üretici tavsiyelerine göre olduğunda kum filtrasyonu sırasında tutulması beklenir. Bu nedenle, aşağıdaki durumlar kontrol edilmelidir: toplam KOI ile çözünür KOI arasındaki ilişki, kullanılan tane boyutu.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '246',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Çözünmeyen Toplam N\'in ACF filtre girişinde bulunmaması gerekir çünkü bu, filtreleme medyasının kirlenmesine neden olur. Kirlenmenin varlığı ortadan kaldırılmalıdır. Filtreleme ortamının kirlenmesi durumunda, bu birim iyi çalışmayacak ve Toplam N\'de olası uyumsuzluklara neden olabilir. Bu nedenle, çözünmeyen Toplam N\'in ACF filtre girişine girmesini önlemek için önceki koagülasyon + flokülasyon + kum filtre birimleri iyi çalıştırılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '247',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Çözünmeyen Toplam N\'in, partikül boyutu 20-50 mikron arasında ve kullanılan tane boyutu üretici tavsiyelerine göre olduğunda kum filtrasyonu sırasında tutulması beklenir. Bu nedenle, aşağıdaki durumlar kontrol edilmelidir: toplam Toplam-N ile çözünür Toplam-N arasındaki ilişki, kullanılan tane boyutu.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '248',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Çözünmeyen Toplam P\'in ACF filtre girişinde bulunmaması gerekir çünkü bu, filtreleme medyasının kirlenmesine neden olur. Kirlenmenin varlığı ortadan kaldırılmalıdır. Filtreleme ortamının kirlenmesi durumunda, bu birim iyi çalışmayacak ve fosfor ile ilgili olası uyumsuzluklara neden olabilir. Bu nedenle, çözünmeyen Toplam P\'nin ACF filtre girişine girmesini önlemek için önceki koagülasyon + flokülasyon + kum filtre birimleri iyi çalıştırılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '249',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Çözünmeyen Toplam P\'in, partikül boyutu 20-50 mikron arasında ve kullanılan tane boyutu üretici tavsiyelerine göre olduğunda kum filtrasyonu sırasında tutulması beklenir. Bu nedenle, aşağıdaki durumlar kontrol edilmelidir: toplam Toplam-P ile çözünür Toplam-P arasındaki ilişki, kullanılan tane boyutu.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '250',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Çözünmeyen renkli boyaların, partikül boyutu 20-50 mikron arasında ve kullanılan tane boyutu üretici tavsiyelerine göre olduğunda kum filtrasyonu sırasında tutulması beklenir. Bu nedenle, aşağıdaki durumlar kontrol edilmelidir: toplam renkli boya ile çözünür renkli boya arasındaki ilişki, kullanılan tane boyutu.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '251',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Çözünmeyen renkli boyalar ACF filtre girişinde bulunmamalıdır çünkü bu, filtreleme medyasının kirlenmesine neden olur. Kirlenmenin varlığı ortadan kaldırılmalıdır. Filtreleme ortamının kirlenmesi durumunda, bu birim iyi çalışmayacak ve renk parametresinde olası uyumsuzluklara neden olabilir. Bu nedenle, çözünmeyen renkli boyaların ACF filtre girişine girmesini önlemek için önceki koagülasyon + flokülasyon + kum filtre birimleri iyi çalıştırılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '252',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Çözünmeyen veya yağlı maddeler filtre kapasitesinde kayba neden olacak ve filtreleme medyasını ciddi şekilde kirletecektir, bu nedenle iyi performans elde etmek için bunlardan kaçınılmalıdır. Bunun için, yağ ve gres parametresine yönelik eylemlere bakılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: [
      'Kobalt',
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Nikel',
      'Gümüş',
      'Cıva',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '253',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Çözünmeyen veya yağlı maddeler filtreleme medyasını ciddi şekilde kirletecektir. Bunlardan kaçınmak için (bu maddeler iyi çalışmazsa, bu BOI5\'te uyumsuzluk yaratabilir), bu maddeler filtre girişinde bulunmamalıdır. Bunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['BOİ5', 'Renk [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '254',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Çözünmeyen veya yağlı maddeler filtreleme medyasını ciddi şekilde kirletecektir. Bunlardan kaçınmak için (bu maddeler iyi çalışmazsa, bu KOI\'da uyumsuzluk yaratabilir), bu maddeler filtre girişinde bulunmamalıdır. Bunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '255',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Çözünmeyen veya yağlı maddeler filtreleme medyasını ciddi şekilde kirletecektir. Bunlardan kaçınmak için (bu maddeler iyi çalışmazsa, bu Toplam N\'de uyumsuzluk yaratabilir), bu maddeler filtre girişinde bulunmamalıdır. Bunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '256',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Çözünmeyen veya yağlı maddeler filtreleme medyasını ciddi şekilde kirletecektir. Bunlardan kaçınmak için (bu maddeler iyi çalışmazsa, bu Toplam P\'de uyumsuzluk yaratabilir), bu maddeler filtre girişinde bulunmamalıdır. Bunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Fenol', 'Toplam-P']
  },
  {
    index: '257',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'BOI5\'te uyumsuzluk, suyun (tamamı veya bir kısmı BOI5) biyolojik olarak çözünebilen veya yavaş çözünebilen olmamasından kaynaklanabilir. Biyolojik olarak çözünebilen atık suların KOI/BOI5 oranları 2 ile 3 arasındadır. Oran daha düşükse, kolayca biyolojik olarak çözünebilen atık sular kabul edilir. Oran çok yüksekse (4\'ten fazla), zayıf atık su biyolojik çözünürlüğü gözlemlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '258',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Yağ ve gres izleri, koagülasyon öncesinde floklar üzerine adsorbe edilebilir. Alüminyum koagülant kaynağı olarak Al poliklorür kullanımı tercih edilir. Alüminyum koagülant, 6,5 ile 7,5 arasında pH değerleri gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Yağ ve Gres']
  },
  {
    index: '259',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Yağ ve gres izleri, koagülasyon öncesinde floklar üzerine adsorbe edildiğinde flokülasyon yapabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Yağ ve Gres']
  },
  {
    index: '260',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Yağlı sular, filtre kapasitesinde kayba neden olacak ve iyi performans elde etmek için kaçınılmalıdır (bu iyi çalışmazsa, BOI5\'te uyumsuzluk yaratabilir). Bunun için, yağ ve gres parametresine yönelik eylemlere bakılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '261',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Yağlı sular, filtre kapasitesinde kayba neden olacak ve iyi performans elde etmek için kaçınılmalıdır (bu iyi çalışmazsa, Toplam P\'de uyumsuzluk yaratabilir). Bunun için, yağ ve gres parametresine yönelik eylemlere bakılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '262',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Yağlı sular, filtre kapasitesinde kayba neden olacak ve iyi performans elde etmek için kaçınılmalıdır (bu iyi çalışmazsa, KOI\'da uyumsuzluk yaratabilir). Bunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '263',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Yağlı sular, filtre kapasitesinde kayba neden olacak ve iyi performans elde etmek için kaçınılmalıdır (bu iyi çalışmazsa, Toplam N\'de uyumsuzluk yaratabilir). Bunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '264',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Yağlı sular, filtre kapasitesinde kayba neden olacak ve iyi performans elde etmek için kaçınılmalıdır. Bunun için, yağ ve gres parametresine yönelik eylemlere bakılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '265',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: 'Ancak büyük yağ kümeleri durumunda, ince ekranlama faydalı olabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Yağ ve Gres']
  },
  {
    index: '266',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Sadece çözünmeyen boyalar ve renklendiriciler kimyasal koagülasyon ile ayrılabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '267',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Sadece gerçekten biyolojik olarak çözünebilen (bKOI) maddeler biyolojik bir süreçle işlenebilir. Biyolojik olarak çözünebilen KOI, atık su arıtma tesisi deşarjında bulunmamalıdır. Çözünmeyen fraksiyon (dayanıklı KOI) biyolojik olarak ortadan kaldırılamaz. Arıtma Notu: Biyolojik olarak çözünebilen atık sular genellikle KOI/BOI5 oranlarını 2 ile 3 arasında gösterir. Oran daha düşükse, kolayca biyolojik olarak çözünebilen atık sular olarak kabul edilir. Oran çok yüksekse (4\'ten fazla), zayıf atık su biyolojik çözünürlüğü beklenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '268',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Ortofosfat şu yöntemlerle çökeltilir: (a) Fe1.6(H2PO4)(OH)3.8 üzerine dayalı yüzey kompleksasyonu modeline göre ferrik klorür kullanılarak / (b) pH 10\'dan fazla arttığında, Ca(OH)2 gibi bir kalsiyum kaynağı kullanılarak fazla kalsiyum iyonları fosfat ile reaksiyona girerek hidroksiapatit [Ca5(OH)(PO4)3] çökelir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '269',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'PID önerilir ve dozaj akışına göre ayarlanması gerekir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['pH']
  },
  {
    index: '270',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Kalıcı köpük genellikle aktif çamur sürecinin havalandırılan bölmelerinde artış gösterecektir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Kalıcı Köpük']
  },
  {
    index: '271',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'Fenoller, aktif karbona adsorbe edilmesi beklenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['Fenol']
  },
  {
    index: '272',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Basınçlı kum filtresi, AKM kontrolü için özel bir süreçtir. Filtre girişindeki AKM konsantrasyonları < 100-200 ppm (<200-400 NTU) olmalıdır. Bu durumda, önceki koagülasyon-flokülasyon-çökelme işlemlerinin performansının iyileştirilmesi gerekmektedir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '273',
    typeId: 'atıksu',
    category: ['Toplama tankı'],
    text: 'Kimyasal dozaj kullanılarak, koleksiyon tanklarında (mümkünse) hafif alkali pH değerleri (7 ile 8 arasında) önerilmektedir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['pH']
  },
  {
    index: '274',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Krom6+\'nın 3+\'a azaltılması, hidroksit minimum çözünürlüğü, reaktif olarak sodyum hidroksit kullanılarak pH 7,5\'te elde edilir. Çökelme pH\'a hassastır çünkü oluşan çökeltinin yeniden çözünürlük oranı pH\'a bağlıdır. Kireç kullanırken, ortak çöktürme pH 8\'de çalışıldığında daha iyi sonuçlar elde edilmesini sağlar ve reaksiyon pH\'tan daha az bağımsız hale gelir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Chrom (VI)']
  },
  {
    index: '275',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'Kum filtrasyon kapasitesi AKM partikülleri için 20-50 mikron ile sınırlıdır. Bu nedenle, partikül boyutu daha küçükse AKM\'de uyumsuzluk oluşabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '276',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Çökelme süreçlerinin 10ºC\'nin üzerinde işletilmesi önerilmektedir çünkü viskozite artışı agregaların aşağı yönlü hızının azalmasına neden olur. Aksi takdirde, su ısıtılmalıdır (örneğin, bir ısı pompası veya ısı değiştirici ile).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Cıva']
  },
  {
    index: '277',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Çökelme süreçlerinin 10ºC\'nin üzerinde çalıştırılması önerilir, çünkü viskozitedeki artış, agregaların aşağı doğru hareket hızını azaltır. Bu nedenle, suyun sıcaklığının 10ºC\'nin üzerinde olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Nikel']
  },
  {
    index: '278',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Çökelme süreçlerinin 10ºC\'nin üzerinde çalıştırılması önerilir, çünkü viskozitedeki artış, agregaların aşağı doğru hareket hızını azaltır. Bu nedenle, suyun sıcaklığının 10ºC\'nin üzerinde olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5', 'Kadmiyum']
  },
  {
    index: '279',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Çökelme süreçlerinin 10ºC\'nin üzerinde çalıştırılması önerilir, çünkü viskozitedeki artış, agregaların aşağı doğru hareket hızını azaltır. Bu nedenle, suyun sıcaklığının 10ºC\'nin üzerinde olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Sülfür',
      'Arsenik',
      'Antimon',
      'Gümüş',
      'Toplam-P',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun'
    ]
  },
  {
    index: '280',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Çökelme süreçlerinin 10ºC\'nin üzerinde çalıştırılması önerilir, çünkü viskozitedeki artış, agregaların aşağı doğru hareket hızını azaltır. Bu nedenle, suyun sıcaklığının 10ºC\'nin üzerinde olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '281',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Çökelme süreçlerinin 10ºC\'nin üzerinde çalıştırılması önerilir, çünkü viskozitedeki artış, agregaların aşağı doğru hareket hızını azaltır. Bu nedenle, suyun sıcaklığının 10ºC\'nin üzerinde olduğundan emin olunmalıdır. Aksi takdirde, su ısıtılmalıdır (örneğin, bir ısı pompası veya ısı değiştirici ile).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Bakır']
  },
  {
    index: '282',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Çökelme süreçlerinin 10ºC\'nin üzerinde çalıştırılması önerilir, çünkü viskozitedeki artış, agregaların aşağı doğru hareket hızını azaltır. Bu nedenle, suyun sıcaklığının 10ºC\'nin üzerinde olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Yağ ve Gres']
  },
  {
    index: '283',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çökelme süreçlerinin 10ºC\'nin üzerinde çalıştırılması önerilir, çünkü viskozitedeki artış, agregaların aşağı doğru hareket hızını azaltır. Bu nedenle, suyun sıcaklığının 10ºC\'nin üzerinde olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '284',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çökelme süreçlerinin 10ºC\'nin üzerinde çalıştırılması önerilir, çünkü viskozitedeki artış, agregaların aşağı doğru hareket hızını azaltır. Bu nedenle, suyun sıcaklığının 10ºC\'nin üzerinde olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5', 'Toplam-N', 'Toplam-P', 'AKM (Askıda Katı Madde)']
  },
  {
    index: '285',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Gümüş, alüminyum veya demir kullanılarak kopreipitat edilebilir. Ayrıca, pH 11\'de hidroksit olarak çökeltilmiş gümüş elde edilebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Gümüş']
  },
  {
    index: '286',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Gümüş kompleksleşemez. Bu, kompleks oluşturamayacakları anlamına gelir. Metal kompleksi, bir veya daha fazla metal atomunun bir veya daha fazla ligand ile bağlandığı bir bileşiktir. Ligand, bir veya daha fazla atom üzerinden bir metal merkeze bağlanabilen organik bir bileşiktir. Bu nedenle, metalin fizikokimyasal işlemle uzaklaştırılabilmesi için serbest olması gerekir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Gümüş']
  },
  {
    index: '287',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Gümüş aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Gümüş']
  },
  {
    index: '288',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı', 'Flokülasyon'],
    text: 'Çamur Hacmi İndeksi (SVI) ≤ 150 ml/g olmalıdır. SVI, Aktif Çamur Süreci\'ndeki havalandırma tankındaki çamurun çökelme özelliklerini tanımlamak için kullanılır. SVI, 1 gram aktif çamurun 30 dakika çöktükten sonra kapladığı hacmi (mL cinsinden) ifade eder.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Sülfür',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Yağ ve Gres',
      'Nikel',
      'Gümüş',
      'Cıva',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '289',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Çamur yaşı reaktör kontrolü, sıcaklıktan dramatik şekilde etkilenir. Çamur atma oranları, reaktör sıcaklığına (Arrhenius Denklemi açısından) göre ayarlanmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)', 'BOİ5', 'Toplam-N', 'Toplam-P']
  },
  {
    index: '290',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Çamur ekstraksiyon akışı, çamur seviyesinin temiz su yüzeyinin 1 ila 2 metre altında olmasını garanti etmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Sülfür',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Yağ ve Gres',
      'Nikel',
      'Gümüş',
      'Cıva',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '291',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece Antimonun katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Antimon']
  },
  {
    index: '292',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece Arsenikin katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Arsenik']
  },
  {
    index: '293',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece BOI5\'in katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['BOİ5']
  },
  {
    index: '294',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece KOI\'in katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '295',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece Kadmiyumun katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Kadmiyum']
  },
  {
    index: '296',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece Krom6+\'nın katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Chrom (VI)']
  },
  {
    index: '297',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece Kobaltın katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Kobalt']
  },
  {
    index: '298',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece Bakırın katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Bakır']
  },
  {
    index: '299',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece Kurşunun katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Kurşun']
  },
  {
    index: '300',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece Cıvanın katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Cıva']
  },
  {
    index: '301',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece Nikelin katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Nikel']
  },
  {
    index: '302',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece Gümüşün katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Gümüş']
  },
  {
    index: '303',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece Sülfürün katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Sülfür']
  },
  {
    index: '304',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: '1-3 mm\'den büyük katı parçacıkların ayrılması gerekmektedir, böylece Toplam Azotun katılardan gelmesi önlenebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-N']
  },
  {
    index: '305',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: 'Katı parçalar 1-3 mm\'den büyük olmalıdır ve bunlar ayrılmalıdır, böylece Toplam Fosforun katılardan gelmesi önlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam-P']
  },
  {
    index: '306',
    typeId: 'atıksu',
    category: ['Bar ekranı'],
    text: 'Katı parçalar 1-3 mm\'den büyük olmalıdır ve bunlar ayrılmalıdır, böylece Çinkonun katılardan gelmesi önlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Çinko']
  },
  {
    index: '307',
    typeId: 'atıksu',
    category: ['Toplama tankı'],
    text: 'Tank içindeki tabakalanma (stratification) önlenmelidir. Çökelme önlenmek için yeterli karıştırma enerjisi uygulanmalıdır. Önerilen karıştırma enerji yoğunluğu > 35 W/m³.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Bakır',
      'Toplam-N',
      'Kadmiyum',
      'Kobalt',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Gümüş',
      'Toplam-P',
      'Cıva',
      'Toplam Krom',
      'BOİ5',
      'Kurşun',
      'Çinko',
      'Arsenik',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Sülfür',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Nikel'
    ]
  },
  {
    index: '308',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Ani iletkenlik değişiklikleri reaktörde sorunlara yol açar. Homojenizasyon ve konsantrasyon dengesi, reaktör performansı için kritik öneme sahiptir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)', 'BOİ5', 'Toplam-N', 'Toplam-P']
  },
  {
    index: '309',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Sülfit havalandırmalı reaktörde sülfata oksitlenir. Reaktör girişinde 50-100 ppm arasında inhibisyon seviyeleri vardır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Sülfür']
  },
  {
    index: '310',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Sülfürler, koagülan olarak demir(III) klorür (ferric chloride) kullanılarak çöktürülüp ayrılabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Sülfür']
  },
  {
    index: '311',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'Demir(III) klorür kullanılarak çöktürülen sülfürler, agregatların küçük boyutu nedeniyle uygun bir flokülantın seçilmesini gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Sülfür']
  },
  {
    index: '312',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Sülfit havalandırmalı reaktörde sülfata oksitlenir. Ancak, biyolojik reaktördeki sülfit/sülfat içeriği >1.000 ppm olduğunda, atıksu (WW) arıtma kalitesinde sorunlar yaşanacaktır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Sülfit']
  },
  {
    index: '313',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Aydınlatılmış arıtılmış atıksu (WW) içindeki sülfit/sülfat içeriği >1.000 ppm olduğunda, atıksu arıtma kalitesinde sorunlar yaşanacaktır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Sülfit']
  },
  {
    index: '314',
    typeId: 'atıksu',
    category: ['Basınçlı kum filtresi'],
    text: 'AKM, KOI değerlerini etkiler, bu yüzden kum filtreleme girişindeki AKM seviyeleri kontrol edilmelidir. Filtre girişindeki AKM konsantrasyonları < 100-200 ppm (<200-400 NTU) olmalıdır. Bu durumda, önceki koagülasyon-flokülasyon-çökelme işlemlerinin performansının iyileştirilmesi gerekmektedir (AKM parametresine bakınız).',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '315',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybı ve dolayısıyla BOI5\'da (AKM içeriğinden dolayı) uyumsuzluk şu nedenlerden olabilir: çamur flokülasyon kaybı veya çamur işlev bozukluğu performansı. Flokülasyon kaybı genellikle biyolojik reaktördeki toksik etkilerden kaynaklanır (çözülmüş oksijen eksikliği, atıksuda bulunan inhibitörler veya toksik maddeler, örneğin AOX ve fenoller vb.). AKM kaybı ayrıca filamentöz bakterilerin varlığından da kaynaklanabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '316',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybı ve dolayısıyla KOI\'da (AKM içeriğinden dolayı) uyumsuzluk şu nedenlerden olabilir: çamur flokülasyon kaybı veya çamur işlev bozukluğu performansı. Flokülasyonun bozulması genellikle biyolojik reaktördeki toksik etkilerden kaynaklanır (çözülmüş oksijen eksikliği, atıksuda bulunan inhibitörler veya toksik maddeler, örneğin AOX ve fenoller vb.). AKM kaybı ayrıca filamentöz bakterilerin varlığından da kaynaklanabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '317',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybı ve dolayısıyla Toplam Azot\'ta (AKM içeriğinden dolayı) uyumsuzluk şu nedenlerden olabilir: çamur flokülasyon kaybı veya çamur işlev bozukluğu performansı. Flokülasyonun bozulması genellikle biyolojik reaktördeki toksik etkilerden kaynaklanır (çözülmüş oksijen eksikliği, atıksuda bulunan inhibitörler veya toksik maddeler, örneğin AOX ve fenoller vb.). AKM kaybı ayrıca filamentöz bakterilerin varlığından da kaynaklanabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '318',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybı ve dolayısıyla Toplam Fosfor\'da (AKM içeriğinden dolayı) uyumsuzluk şu nedenlerden olabilir: çamur flokülasyon kaybı veya çamur işlev bozukluğu performansı. Flokülasyonun bozulması genellikle biyolojik reaktördeki toksik etkilerden kaynaklanır (çözülmüş oksijen eksikliği, atıksuda bulunan inhibitörler veya toksik maddeler, örneğin AOX ve fenoller vb.). AKM kaybı ayrıca filamentöz bakterilerin varlığından da kaynaklanabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '319',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Çöktürme tankı için doğru sıcaklık 30ºC\'nin altında olmalıdır. Bu nedenle, sıcaklığın uygun olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)', 'Arsenik', 'Sülfür']
  },
  {
    index: '320',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Çöktürme tankı için doğru sıcaklık 30ºC\'nin altında olmalıdır. Bu nedenle, sıcaklığın uygun olduğundan emin olunmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Bakır',
      'Antimon',
      'Nikel',
      'Gümüş',
      'Cıva',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '321',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını önlemek için fenol inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Inhibisyon seviyeleri 50 ila 200 ppm arasında gözlemlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '322',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla BOI5 uyumsuzluğunu) önlemek için AOX inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Inhibisyon seviyeleri 50 ila 200 ppm arasında gözlemlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '323',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla BOI5 uyumsuzluğunu) önlemek için siyanür inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Siyanürler biyolojik reaktör girişinde önlenmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '324',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla BOI5 uyumsuzluğunu) önlemek için fenol inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Inhibisyon seviyeleri 50 ila 200 ppm arasında gözlemlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '325',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla BOI5 uyumsuzluğunu) önlemek için pH kontrol edilmelidir. Düşük veya yüksek pH, çamur çökelme hızını ve kalitesini etkileyebilir. Doğru aralık 7,2 ile 8,2 arasındadır. Düşük pH, bazik bir reaktör (örneğin kostik soda) eklenmesini gerektirirken, yüksek pH, asidik bir reaktör (örneğin sülfürik asit veya hidroklorik asit) eklenmesini gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '326',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla BOI5 uyumsuzluğunu) önlemek için yağ ve gres, reaktör girişinde önlenmelidir. Yağ ve gres, çamur yoğunluğunu azaltır ve çamur çökelme kalitesine ciddi zararlar verir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '327',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla BOI5 uyumsuzluğunu) önlemek için sülfürlerden kaçınılmalıdır. Sülfür aktif çamurda flokülasyon kaybına ve kötü çökmeye neden olabilir. Sülfürler biyolojik reaktör girişinde önlenmelidir. Bunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir. Sülfür parametresindeki tüm eylemleri inceleyin.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '328',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla KOI uyumsuzluğunu) önlemek için AOX inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Inhibisyon seviyeleri 50 ila 200 ppm arasında gözlemlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '329',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla KOI uyumsuzluğunu) önlemek için siyanür inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Siyanürler biyolojik reaktör girişinde önlenmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '330',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla KOI uyumsuzluğunu) önlemek için fenol inhibisyonunu kontrol edin. Fenol seviyeleri önceki ünitede (aerobik reaktör) 50 ila 200 ppm arasında gözlemlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '331',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla KOI uyumsuzluğunu) önlemek için pH kontrol edilmelidir. Düşük veya yüksek pH, çamur çökelme hızını ve kalitesini etkileyebilir. Doğru aralık 7,2 ile 8,2 arasındadır. Düşük pH, bazik bir reaktör (örneğin kostik soda) eklenmesini gerektirirken, yüksek pH, asidik bir reaktör (örneğin sülfürik asit veya hidroklorik asit) eklenmesini gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '332',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla KOI uyumsuzluğunu) önlemek için yağ ve gres, reaktör girişinde önlenmelidir. Yağ ve gres, çamur yoğunluğunu azaltır ve çamur çökelme kalitesine ciddi zararlar verir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '333',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla KOI uyumsuzluğunu) önlemek için sülfürlerden kaçınılmalıdır. Sülfür aktif çamurda flokülasyon kaybına ve kötü çökmeye neden olabilir. Sülfürler biyolojik reaktör girişinde önlenmelidir. Bunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir. Sülfür parametresindeki tüm eylemleri inceleyin.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '334',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla katı madde nedeniyle AKM uyumsuzluğunu) önlemek için pH kontrol edilmelidir. Düşük veya yüksek pH, çamur çökelme hızını ve kalitesini etkileyebilir. Doğru aralık 7,2 ile 8,2 arasındadır. Düşük pH, bazik bir reaktör (örneğin kostik soda) eklenmesini gerektirirken, yüksek pH, asidik bir reaktör (örneğin sülfürik asit veya hidroklorik asit) eklenmesini gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '335',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla AKM uyumsuzluğunu) önlemek için yağ ve gres, reaktör girişinde önlenmelidir. Yağ ve gres, çamur yoğunluğunu azaltır ve çamur çökelme kalitesine ciddi zararlar verir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '336',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Azot uyumsuzluğunu) önlemek için AOX inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Inhibisyon seviyeleri 50 ila 200 ppm arasında gözlemlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '337',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Azot uyumsuzluğunu) önlemek için siyanür inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Siyanürler biyolojik reaktör girişinde önlenmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '338',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Azot uyumsuzluğunu) önlemek için fenol inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Inhibisyon seviyeleri 50 ila 200 ppm arasında gözlemlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '339',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Azot uyumsuzluğunu) önlemek için pH kontrol edilmelidir. Düşük veya yüksek pH, çamur çökelme hızını ve kalitesini etkileyebilir. Doğru aralık 7,2 ile 8,2 arasındadır. Düşük pH, bazik bir reaktör (örneğin kostik soda) eklenmesini gerektirirken, yüksek pH, asidik bir reaktör (örneğin sülfürik asit veya hidroklorik asit) eklenmesini gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '340',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Azot uyumsuzluğunu) önlemek için yağ ve gres, reaktör girişinde önlenmelidir. Yağ ve gres, çamur yoğunluğunu azaltır ve çamur çökelme kalitesine ciddi zararlar verir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '341',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Azot uyumsuzluğunu) önlemek için sülfürlerden kaçınılmalıdır. Sülfür aktif çamurda flokülasyon kaybına ve kötü çökmeye neden olabilir. Sülfürler biyolojik reaktör girişinde önlenmelidir. BBunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir. Sülfür parametresindeki tüm eylemleri inceleyin.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '342',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Fosfor uyumsuzluğunu) önlemek için siyanür inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Siyanürler biyolojik reaktör girişinde önlenmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '343',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Fosfor uyumsuzluğunu) önlemek için AOX inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Inhibisyon seviyeleri 50 ila 200 ppm arasında gözlemlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '344',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Fosfor uyumsuzluğunu) önlemek için fenol inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Inhibisyon seviyeleri 50 ila 200 ppm arasında gözlemlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '345',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Fosfor uyumsuzluğunu) önlemek için pH kontrol edilmelidir. Düşük veya yüksek pH, çamur çökelme hızını ve kalitesini etkileyebilir. Doğru aralık 7,2 ile 8,2 arasındadır. Düşük pH, bazik bir reaktör (örneğin kostik soda) eklenmesini gerektirirken, yüksek pH, asidik bir reaktör (örneğin sülfürik asit veya hidroklorik asit) eklenmesini gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '346',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Fosfor uyumsuzluğunu) önlemek için yağ ve gres, reaktör girişinde önlenmelidir. Yağ ve gres, çamur yoğunluğunu azaltır ve çamur çökelme kalitesine ciddi zararlar verir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '347',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını (ve dolayısıyla Toplam Fosfor uyumsuzluğunu) önlemek için sülfürlerden kaçınılmalıdır. Sülfür aktif çamurda flokülasyon kaybına ve kötü çökmeye neden olabilir. Sülfürler biyolojik reaktör girişinde önlenmelidir. Bunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir. Sülfür parametresindeki tüm eylemleri inceleyin.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '348',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme çıkışında AKM kaybını önlemek ve dolayısıyla AKM\'deki uyumsuzluk şu nedenlerden olabilir: çamur flokülasyon kaybı veya çamur işlev bozukluğu performansı. Flokülasyon kaybı genellikle biyolojik reaktördeki toksik etkilerden kaynaklanır (çözülmüş oksijen eksikliği, atıksuda bulunan inhibitörler veya toksik maddeler, örneğin AOX ve fenoller, siyanürler vb.). AKM kaybı ayrıca filamentöz bakterilerin varlığından da kaynaklanabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '349',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını önlemek için AOX inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Inhibisyon seviyeleri 50 ila 200 ppm arasında gözlemlenir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '350',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını önlemek için siyanür inhibisyonunu bir önceki ünitede (aerobik reaktör) kontrol edin. Siyanürler biyolojik reaktör girişinde önlenmelidir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '351',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını önlemek için, ÇAMUR HACİM İNDEKSİ (SVI) ≤ 150 ml/g olmalıdır. SVI, Aktif Çamur Süreci\'ndeki havalandırma tankındaki çamurun çökelme özelliklerini tanımlamak için kullanılır. SVI, 1 gram aktif çamurun 30 dakika çöktükten sonra kapladığı hacmi (mL cinsinden) ifade eder.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N', 'KOİ (Kimyasal Oksijen İhtiyacı)', 'Toplam-P', 'AKM (Askıda Katı Madde)', 'BOİ5']
  },
  {
    index: '352',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını önlemek için, suyun iletkenliğinin doğru olduğundan emin olunmalıdır. Yüksek iletkenlik/salinite, aktif çamur çökelme performansını bozacaktır. Reaktör girişindeki klorür seviyeleri <10.000 ppm ve sülfat seviyeleri <1.000 ppm olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '353',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybınıı önlemek için, suyun iletkenliğinin doğru olduğundan emin olunmalıdır. Ani iletkenlik değişimleri, çöktürme üzerinde etkiler yaratabilir. Homojenizasyon ve konsantrasyon dengeleri, reaktörün doğru performansı için kritik öneme sahiptir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '354',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çöktürme tankı çıkışında AKM kaybını önlemek için sülfürlerden kaçınılmalıdır. Sülfür aktif çamurda flokülasyon kaybına ve kötü çökmeye neden olabilir. Sülfürler biyolojik reaktör girişinde önlenmelidir. Bunun için, önceki arıtma işlemlerinin düzgün bir şekilde çalıştırılması gerekmektedir. Sülfür parametresindeki tüm eylemleri inceleyin.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '355',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Biyolojik reaktör girişindeki toplam katıların artışını önlemek için, önceki adımlar iyi çalışmalıdır (bar ekranı ve koagülasyon/flokülasyon ünitesi işlemlerinin doğru bir şekilde işletilmesi). Büyük miktardaki AKM, oksijen tüketiminde (SOUR: spesifik oksijen alım oranı) dramatik bir düşüşe neden olabilir. Bu, reaktör stabilitesi için tehlikeli olabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '356',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Biyolojik reaktör girişindeki toplam katıların artışını önlemek için, önceki adımlar iyi çalışmalıdır (bar ekranı ve koagülasyon/flokülasyon ünitesi işlemlerinin doğru bir şekilde işletilmesi). Biyolojik reaktör girişindeki AKM, çamur atım oranı ayarına dikkat edilmelidir. Atıksu kaynaklı katı maddelerle reaktörü aşırı yüklememek için, biyolojik reaktör girişindeki AKM konsantrasyonları > 100 ppm olmamalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '357',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'BOI5 performansındaki işlev bozukluklarını önlemek için, reaktör girişinde yağ ve greslerden kaçınılmalıdır. Yağ ve gresler biyolojik olarak parçalanamaz, çünkü çözünür değillerdir ve aktif çamurda ciddi işlev bozukluklarına neden olabilirler, örneğin kötü oksijen transferi ve filamentöz gibi çökme yapmayan bakterilerin varlığı.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '358',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'KOI performansındaki işlev bozukluklarını önlemek için, reaktör girişinde yağ ve greslerden kaçınılmalıdır. Yağ ve gresler biyolojik olarak parçalanamaz, çünkü çözünür değillerdir ve aktif çamurda ciddi işlev bozukluklarına neden olabilirler, örneğin kötü oksijen transferi ve filamentöz gibi çökme yapmayan bakterilerin varlığı.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '359',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'AKM performansındaki işlev bozukluklarını önlemek için, reaktör girişinde yağ ve greslerden kaçınılmalıdır. Yağ ve gresler biyolojik olarak parçalanamaz, çünkü çözünür değillerdir ve aktif çamurda ciddi işlev bozukluklarına neden olabilirler, örneğin kötü oksijen transferi ve filamentöz gibi çökme yapmayan bakterilerin varlığı.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '360',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Toplam Fosfor performansındaki işlev bozukluklarını önlemek için, reaktör girişinde yağ ve greslerden kaçınılmalıdır. Yağ ve gresler biyolojik olarak parçalanamaz, çünkü çözünür değillerdir ve aktif çamurda ciddi işlev bozukluklarına neden olabilirler, örneğin kötü oksijen transferi ve filamentöz gibi çökme yapmayan bakterilerin varlığı.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '361',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Toplam Azot performansındaki işlev bozukluklarını önlemek için, reaktör girişinde yağ ve greslerden kaçınılmalıdır. Yağ ve gresler biyolojik olarak parçalanamaz, çünkü çözünür değillerdir ve aktif çamurda ciddi işlev bozukluklarına neden olabilirler, örneğin kötü oksijen transferi ve filamentöz gibi çökme yapmayan bakterilerin varlığı.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '362',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'BOI5\'te uyumsuzlukları önlemek için, sürecin yakından kontrolü zorunludur, özellikle SOUR reaktör kontrolü. Ayrıca, inhibitörler biyolojik reaktör performansında ciddi işlev bozukluklarına neden olabilir (aşağıdaki parametrelerin reaktör girişinde bulunmamasına dikkat edilmelidir: AOX, fenoller, belirli seviyelerde ağır metaller, sülfür, sülfit ve siyanür). İnhibitör seviyelerini kontrol edin ve özel parametrelerin aksiyonlarında nasıl azaltılacağını öğrenin.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '363',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'KOI\'de uyumsuzlukları önlemek için, sürecin yakından kontrolü zorunludur, özellikle SOUR reaktör kontrolü. Ayrıca, inhibitörler biyolojik reaktör performansında ciddi işlev bozukluklarına neden olabilir (aşağıdaki parametrelerin reaktör girişinde bulunmamasına dikkat edilmelidir: AOX, fenoller, belirli seviyelerde ağır metaller, sülfür, sülfit ve siyanür). İnhibitör seviyelerini kontrol edin ve özel parametrelerin aksiyonlarında nasıl azaltılacağını öğrenin.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '364',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Toplam P\'de uyumsuzlukları önlemek için, sürecin yakından kontrolü zorunludur, özellikle SOUR reaktör kontrolü. Ayrıca, inhibitörler biyolojik reaktör performansında ciddi işlev bozukluklarına neden olabilir (aşağıdaki parametrelerin reaktör girişinde bulunmamasına dikkat edilmelidir: AOX, fenoller, belirli seviyelerde ağır metaller, sülfür, sülfit ve siyanür). İnhibitör seviyelerini kontrol edin ve özel parametrelerin aksiyonlarında nasıl azaltılacağını öğrenin.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-P']
  },
  {
    index: '365',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Toplam azotta uyumsuzlukları önlemek için, sürecin yakından kontrolü zorunludur, özellikle SOUR reaktör kontrolü. Ayrıca, inhibitörler biyolojik reaktör performansında ciddi işlev bozukluklarına neden olabilir (aşağıdaki parametrelerin reaktör girişinde bulunmamasına dikkat edilmelidir: AOX, fenoller, belirli seviyelerde ağır metaller, sülfür, sülfit ve siyanür). İnhibitör seviyelerini kontrol edin ve özel parametrelerin aksiyonlarında nasıl azaltılacağını öğrenin.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '366',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'KOI\'de uyumsuzlukları önlemek için, aktif karbon, kontrol edilecek kimyasal parametre türüne göre seçilmelidir. Tane boyutu, gözenek boyutu ve karbon türü filtre üreticisi tavsiyelerine göre seçilmelidir. Su bileşiminizin değişip değişmediğini ve karbon türü veya tane boyutunu değiştirmeniz gerekip gerekmediğini kontrol edin. Unutmayın ki polar ve düşük moleküler ağırlıklı maddeler aktif karbon gözeneklerinde zayıf bir şekilde tutulur.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '367',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Toplam Krom, konsantrasyonları > 1 ila 100 ppm olduğunda aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam Krom']
  },
  {
    index: '368',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Toplam biyolojik olarak parçalanabilir azotun biyolojik reaktörde azalması, nitrifikasyon/dinitrifikasyon kombinasyonlu bir süreç gerektirir. Nitrifikasyon için havalandırmalı bir reaktör ve dinitrifikasyon için anoksik bir reaktör kombinleyen özel bir süreç tasarımı gereklidir. Öte yandan, biyolojik olarak parçalanmayan azot veya nitrifikasyon/dinitrifikasyon için teknoloji eksikliği, reaktör ve çöktürme tankı çıkışında toplam azot konsantrasyonlarına yol açacaktır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N']
  },
  {
    index: '369',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Toplam krom kompleksleşemez. Bu, kompleks oluşturamayacakları anlamına gelir. Metal kompleksi, bir veya daha fazla metal atomunun bir veya daha fazla ligand ile bağlandığı bir bileşiktir. Ligand, bir veya daha fazla atom üzerinden bir metal merkeze bağlanabilen organik bir bileşiktir. Bu nedenle, metalin fizikokimyasal işlemle uzaklaştırılabilmesi için serbest olması gerekir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Toplam Krom']
  },
  {
    index: '370',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'V30\' ölçümleri ve SVI değerleri, çöktürme tankı çıkışında olası AKM kaybını kontrol etmek ve AKM uyumsuzluğunu önlemek için < 150 ml/g değerlerinde tutulmalıdır. Katı madde içeriği, aşağıdaki durumlarda çökelme sürecini önemli ölçüde etkilemeyecektir: katı madde içeriği 150 ppm\'den az veya eşit olduğunda ve bu katı maddeler flok yoğunluğunu azaltmadığında.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '371',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Dozaj noktasında çok yüksek karıştırma yoğunluğu (G değerleri 200 ile 300 saniye‐1 arasında) önerilmektedir. Yüksek enerji ile karıştırma süreleri genellikle 10 ile 30 saniye arasındadır. Bu karıştırma işleminden sonra mevcut koagülasyon uygulanmalıdır. Reaksiyon havuzu tamamen karıştırılmalı ve ölü hacim olmamalıdır. Karıştırma pompası > 100 tank hacmi /sa.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Nikel',
      'Gümüş',
      'Cıva',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '372',
    typeId: 'atıksu',
    category: ['Aktif karbon filtresi'],
    text: 'ACF girişindeki çok düşük AKM içeriği tavsiye edilir. Filtrasyon kontaminasyonunu önlemek için 2,5 ppm\'den ( < 5 NTU) az olmalıdır. Bu birimin girişindeki suyun bulanıklığı kontrol edilmelidir. Eğer 5 NTU\'den fazlaysa, basınçlı kum filtresindeki işlemi yoğunlaştırın.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 2'],
    parameter: ['AKM (Askıda Katı Madde)']
  },
  {
    index: '373',
    typeId: 'atıksu',
    category: ['Sedimantasyon tankı'],
    text: 'Savak hızı < 4 m³/h/m olmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Çinko',
      'Sülfür',
      'Arsenik',
      'Bakır',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Yağ ve Gres',
      'Nikel',
      'Gümüş',
      'Cıva',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Toplam Krom',
      'Kurşun',
      'Kadmiyum'
    ]
  },
  {
    index: '374',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Yüksek alkalinite durumunda, güçlü nötralizasyon kimyasalları kullanılabilir, örneğin: mineral asitler H2SO4/HCl ve NaOH. Buffere alma dikkate alınmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['pH']
  },
  {
    index: '375',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Al polikloridleri kullanırken, koagülasyon-flokülasyon reaksiyonu için pH kontrolü çok önemlidir. pH\'ın 6,5 ile 7,5 arasında tutulması önerilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Renk [m-1] (436 nm; 525 nm; 620 nm)']
  },
  {
    index: '376',
    typeId: 'atıksu',
    category: ['Toplama tankı'],
    text: 'Hava oksidasyon, septik kontrol veya karıştırıcı olarak kullanıldığında ve yüksek çözünmüş CO2 oranına sahip sularla birlikte, CO2 çıkarılması nedeniyle pH 8-9\'a alkali bir kayma gözlemlenebilir. Bu durumda, pH\'ı, bir sonraki adımda kullanılacak koagülanın optimum değerine ayarlamak için asidik bir reaktanın eklenmesi gerekecektir. Bu pH ayarı toplama tankında veya koagülasyon tankında yapılabilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['pH']
  },
  {
    index: '377',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Çinko hidroksit olarak çökeltilir. Minimum çözünürlük pH 9 - 9,5 ile 11 arasında, sodyum hidroksit veya kireç kullanılarak elde edilir. Her iki reaktanın kullanılması benzer sonuçlar verir. Çökelme, çökeltilen malzemenin yeniden çözünmesi nedeniyle pH\'ya hassastır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Çinko']
  },
  {
    index: '378',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'Çinko kompleksleşemez. Bu, kompleks oluşturamayacakları anlamına gelir. Metal kompleksi, bir veya daha fazla metal atomunun bir veya daha fazla ligand ile bağlandığı bir bileşiktir. Ligand, bir veya daha fazla atom üzerinden bir metal merkeze bağlanabilen organik bir bileşiktir. Bu nedenle, metalin fizikokimyasal işlemle uzaklaştırılabilmesi için serbest olması gerekir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['Çinko']
  },
  {
    index: '379',
    typeId: 'atıksu',
    category: ['İkincil çökeltme'],
    text: 'Çinko, konsantrasyonları > 0,3 ile 5 ppm arasında olan aktif çamur için biyolojik olarak toksiktir ve reaktör girişinde bulunmaktan önlenmelidir. Herhangi bir arıtma beklenmemektedir. Aktif çamurda birikimden kaçınılmalıdır.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Çinko']
  },
  {
    index: '380',
    typeId: 'atıksu',
    category: ['Koagülasyon'],
    text: 'pH probu temiz ve kalibre edilmiş olmalıdır (haftada bir önerilir). Eğer pH sensörü doğru ölçüm yapmıyorsa ve pH\'ı ayarlamak için kimyasal madde dozajı sensör okumalarına bağlıysa, bu parametrede uyumsuzluk meydana gelebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: ['pH']
  },
  {
    index: '381',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Biyolojik reaktörde pH aralığı 7,2 ila 8,2 arasında olmalıdır. Genellikle pH düzeltmesi gereklidir. Düşük pH, bazik bir reaktif (örneğin kostik soda) eklenmesini gerektirirken, yüksek pH, asidik bir reaktif (örneğin sülfürik asit veya hidroklorik asit) eklenmesini gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['KOİ (Kimyasal Oksijen İhtiyacı)']
  },
  {
    index: '382',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Biyolojik reaktörde pH aralığı 7,2 ila 8,2 arasında olmalıdır. Genellikle pH düzeltmesi gereklidir. Düşük pH, bazik bir reaktif (örneğin kostik soda) eklenmesini gerektirirken, yüksek pH, asidik bir reaktif (örneğin sülfürik asit veya hidroklorik asit) eklenmesini gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['BOİ5']
  },
  {
    index: '383',
    typeId: 'atıksu',
    category: ['Aerobik reaktör'],
    text: 'Biyolojik reaktörde pH aralığı 7,2 ila 8,2 arasında olmalıdır. Genellikle pH düzeltmesi gereklidir. Düşük pH, bazik bir reaktif (örneğin kostik soda) eklenmesini gerektirirken, yüksek pH, asidik bir reaktif (örneğin sülfürik asit veya hidroklorik asit) eklenmesini gerektirir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 3'],
    parameter: ['Toplam-N', 'Toplam-P']
  },
  {
    index: '384',
    typeId: 'atıksu',
    category: ['Flokülasyon'],
    text: 'pH değerleri >8, bazı anyonik polielektrolitlerin flokülasyon kapasitesini etkileyebilir.',
    manufacturingProcess: [
      'Kontinü boyama',
      'Çektirme boyama',
      'Yıkama',
      'Deri',
      'Genel baskı',
      'Parça baskı',
      'Diğer'
    ],
    etpType: ['ETP tür 1', 'ETP tür 3', 'ETP tür 2'],
    parameter: [
      'Bakır',
      'Toplam-N',
      'Kadmiyum',
      'Yağ ve Gres',
      'KOİ (Kimyasal Oksijen İhtiyacı)',
      'Gümüş',
      'Toplam-P',
      'Cıva',
      'Toplam Krom',
      'BOİ5',
      'Kurşun',
      'Çinko',
      'Arsenik',
      'AKM (Askıda Katı Madde)',
      'Chrom (VI)',
      'Sülfür',
      'Antimon',
      'Renk [m-1] (436 nm; 525 nm; 620 nm)',
      'Nikel'
    ]
  }
];
